
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lJ6db", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");



var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $cha5E = parcelRequire("cha5E");


var $a33Aa = parcelRequire("a33Aa");


var $bjY3F = parcelRequire("bjY3F");


var $hlvTd = parcelRequire("hlvTd");


var $5XWbo = parcelRequire("5XWbo");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $jTKfH = parcelRequire("jTKfH");


var $5rzIE = parcelRequire("5rzIE");


var $7zss8 = parcelRequire("7zss8");


var $gB5in = parcelRequire("gB5in");


var $bQQtO = parcelRequire("bQQtO");


var $fDfQA = parcelRequire("fDfQA");


var $emCLk = parcelRequire("emCLk");


var $5suST = parcelRequire("5suST");


var $irsyK = parcelRequire("irsyK");


var $7td41 = parcelRequire("7td41");


var $bkEBw = parcelRequire("bkEBw");

const $a1ccb2b7a1450c9c$var$addRequestBreadcrumb = ({ durationMs: durationMs, lifecycle: lifecycle, options: options, status: status })=>{
    (0, $hlvTd.addSentryBreadcrumb)({
        category: 'request',
        data: {
            durationMs: durationMs === undefined ? undefined : Math.round(durationMs),
            lifecycle: lifecycle,
            method: (options.options.method ?? 'GET').toUpperCase(),
            operation: options.holdName,
            route: (0, $5rzIE.normalizeRequestRoute)(options.path),
            status: status
        },
        message: `${options.options.method ?? 'GET'} ${options.holdName ?? (0, $5rzIE.normalizeRequestRoute)(options.path)} ${lifecycle}`,
        type: 'http'
    });
};
const $a1ccb2b7a1450c9c$var$observeStreamLifecycle = async function*(generator, options) {
    const startedAt = performance.now();
    let firstDataReceived = false;
    let lifecycleEnded = false;
    $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
        lifecycle: 'started',
        options: options
    });
    try {
        for await (const value of generator){
            if (!firstDataReceived) {
                firstDataReceived = true;
                $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                    durationMs: performance.now() - startedAt,
                    lifecycle: 'firstData',
                    options: options
                });
            }
            yield value;
        }
        lifecycleEnded = true;
        $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: options.options.signal?.aborted ? 'abort' : 'completed',
            options: options
        });
    } catch (error) {
        lifecycleEnded = true;
        $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: error instanceof Error && error.name === 'AbortError' ? 'abort' : error instanceof Error && /timeout/i.test(error.name) ? 'timedOut' : 'error',
            options: options
        });
        throw error;
    } finally{
        if (!lifecycleEnded) $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
            durationMs: performance.now() - startedAt,
            lifecycle: options.options.signal?.aborted ? 'abort' : 'cancelled',
            options: options
        });
    }
};
const $a1ccb2b7a1450c9c$var$PRODUCT_HEADER = 'x-product';
/** Number of tasks to request per page when using cursor-based pagination. */ const $a1ccb2b7a1450c9c$var$TASKS_PAGE_SIZE = 25;
const $a1ccb2b7a1450c9c$var$LIBRARY_PAGE_SIZE = 25;
const $a1ccb2b7a1450c9c$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER = 'x-cloudid';
const $a1ccb2b7a1450c9c$var$GATEWAY_BASE_URL = '/gateway/api';
const $a1ccb2b7a1450c9c$var$AGENT_SESSION_STATE_VALUES = new Set([
    'WORKING',
    'INPUT_REQUIRED',
    'ARTEFACT_READY',
    'AUTH_REQUIRED',
    'FAILED',
    'REJECTED',
    'COMPLETED',
    'CANCELLED',
    'UNKNOWN'
]);
const $a1ccb2b7a1450c9c$var$isAgentSessionState = (value)=>$a1ccb2b7a1450c9c$var$AGENT_SESSION_STATE_VALUES.has(value);
const $a1ccb2b7a1450c9c$var$hasCloudIdHeader = (headers)=>Object.keys(headers).some((name)=>name.toLowerCase() === $a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER);
const $a1ccb2b7a1450c9c$var$DEFAULT_FILE_VALIDATE_PATH = '/rovo/v1/chat/message/file/validate';
const $a1ccb2b7a1450c9c$var$DEFAULT_FILE_UPLOAD_PATH = '/rovo/v1/chat/message/file';
class $a1ccb2b7a1450c9c$export$40a7802808e2fbe3 {
    createHeaders(init) {
        const configHeaders = this.config.headers || {};
        return new Headers({
            [$a1ccb2b7a1450c9c$var$PRODUCT_HEADER]: this.config.product,
            [$a1ccb2b7a1450c9c$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.siteId && (0, $iDrrr.fg)('rovo_chat_site_switch_reset') && !$a1ccb2b7a1450c9c$var$hasCloudIdHeader(configHeaders) ? {
                [$a1ccb2b7a1450c9c$var$CLOUD_ID_HEADER]: this.config.siteId
            } : {},
            ...configHeaders,
            ...this.config.channelId ? {
                [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.config.channelId
            } : {},
            ...init
        });
    }
    getChannelId(defaultChannelId) {
        return this.config.channelId || defaultChannelId;
    }
    async fetch({ path: path, options: options, holdName: holdName, baseUrl: requestBaseUrl }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = requestBaseUrl ?? configBaseUrl;
        const requestUrl = (0, $irsyK.addPath)(baseUrl, path);
        const startTime = performance.now();
        if (!(0, $hlvTd.isIsolatedSentryReportingSelected)()) {
            const response = await window.fetch(requestUrl, {
                credentials: configCredentials,
                ...options
            });
            if (this.config.labelStack) {
                // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
                // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
                // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
                const endTime = performance.now();
                (0, $a33Aa.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
            }
            return (0, $irsyK.processResponse)({
                response: response
            });
        }
        try {
            const response = await window.fetch(requestUrl, {
                credentials: configCredentials,
                ...options
            });
            if (this.config.labelStack) {
                // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
                // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
                // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
                const endTime = performance.now();
                (0, $a33Aa.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
            }
            const processedResponse = await (0, $irsyK.processResponse)({
                response: response
            });
            $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                durationMs: performance.now() - startTime,
                lifecycle: 'success',
                options: {
                    path: path,
                    options: options,
                    holdName: holdName
                },
                status: response.status
            });
            return processedResponse;
        } catch (error) {
            $a1ccb2b7a1450c9c$var$addRequestBreadcrumb({
                durationMs: performance.now() - startTime,
                lifecycle: error instanceof (0, $8A2GO.ApiError) ? 'httpError' : error instanceof Error && error.name === 'AbortError' ? 'abort' : 'networkError',
                options: {
                    path: path,
                    options: options,
                    holdName: holdName
                },
                status: error instanceof (0, $8A2GO.ApiError) ? error.errorAttributes.statusCode : undefined
            });
            throw error;
        }
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async getConversationSharePreview(_payload) {
        throw new (0, $8A2GO.ApiError)('Share preview not found', {
            statusCode: 404
        });
    }
    async getConversationShareMetadata(_payload) {
        throw new (0, $8A2GO.ApiError)('Share metadata not found', {
            statusCode: 404
        });
    }
    async fetchStream(options, config) {
        const response = await this.fetch(options);
        const contentType = response.headers.get('content-type') ?? '';
        const headerSuggestsSSE = config?.useSSE && contentType.includes('text/event-stream');
        const shouldObserveStream = (0, $hlvTd.isIsolatedSentryReportingSelected)();
        return {
            responseData: {
                traceId: (0, $jTKfH.getTraceIdFromResponse)(response)
            },
            generator: headerSuggestsSSE ? shouldObserveStream ? $a1ccb2b7a1450c9c$var$observeStreamLifecycle((0, $emCLk.readSSEStream)(response), options) : (0, $emCLk.readSSEStream)(response) : shouldObserveStream ? $a1ccb2b7a1450c9c$var$observeStreamLifecycle((0, $fDfQA.readJsonStream)(response), options) : (0, $fDfQA.readJsonStream)(response)
        };
    }
    constructor(props){
        this.config = void 0;
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
}
class $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94 extends $a1ccb2b7a1450c9c$export$40a7802808e2fbe3 {
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, autoActionApprovalMode: autoActionApprovalMode, mimeType: mimeType, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, writingStyleContext: writingStyleContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, appFilters: appFilters, selectedCloudIds: selectedCloudIds, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, browserContextSanitizer: browserContextSanitizer, optInSSEStream: optInSSEStream = false, agentVersion: agentVersion, spaceId: spaceId, capabilities: capabilities, shouldExtractConversationScopes: shouldExtractConversationScopes, searchArtifact: searchArtifact, parentMessageId: parentMessageId, requestedSkills: requestedSkills }) {
        const effectiveCapabilities = (0, $5suST.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        const selectedCloudIdsOverride = (0, $iDrrr.fg)((0, $5XWbo.ROVO_CHAT_SITES_SOURCE_FILTER_GATE)) && selectedCloudIds && selectedCloudIds.length > 0 ? {
            selectedCloudIds: selectedCloudIds.map((cloudId)=>({
                    cloudId: cloudId
                }))
        } : {};
        const { browserUrl: url, isBrowserContextBlocklisted: isBrowserContextBlocklisted } = (0, $bQQtO.resolveMessageStreamBrowserUrl)({
            browserContext: browserContext,
            browserContextSanitizer: browserContextSanitizer,
            product: this.getConfig().product
        });
        const defaultMimeType = typeof message === 'string' ? 'text/markdown' : 'text/adf';
        const body = {
            content: message,
            context: (0, $gB5in.buildMessageStreamRequestContext)({
                browserUrl: url,
                autoActionApprovalMode: autoActionApprovalMode,
                useCurrentBrowsingContext: useCurrentBrowsingContext,
                webSearchEnabled: webSearchEnabled,
                sourceMode: sourceMode,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                fastModeEnabled: fastModeEnabled,
                planModeEnabled: planModeEnabled,
                editorContext: editorContext,
                whiteboardContext: whiteboardContext,
                slidesContext: slidesContext,
                databaseContext: databaseContext,
                dashboardEditorContext: dashboardEditorContext,
                browserContext: browserContext,
                isBrowserContextBlocklisted: isBrowserContextBlocklisted,
                jiraWorkflowContext: jiraWorkflowContext,
                additionalContext: additionalContext,
                writingStyleContext: writingStyleContext,
                dashboardContext: dashboardContext,
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                knowledgeOverride: knowledgeOverride,
                selectedCloudIdsOverride: selectedCloudIdsOverride,
                searchArtifact: searchArtifact,
                shouldExtractConversationScopes: shouldExtractConversationScopes
            }),
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: mimeType && (0, $iDrrr.fg)('jira_ai_rendering_a2ui') ? mimeType : defaultMimeType,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            // don't allow store message if feature flag is off
            store_message: (0, $iDrrr.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {}),
            ...spaceId ? {
                space_id: spaceId
            } : {},
            ...parentMessageId ? {
                parent_message_id: parentMessageId
            } : {},
            ...requestedSkills?.length ? {
                skills: requestedSkills
            } : {}
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async reconnectToMessageStream({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, controller: controller }) {
        const headers = this.createHeaders();
        // Add Last-Event-ID header if available
        if (lastEventId) headers.set('Last-Event-ID', lastEventId);
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/stream/sse`,
            options: options
        }, {
            useSSE: true
        });
    }
    // Only takes effect if the stream is a Deep Research stream
    async cancelMessageStream({ conversationId: conversationId, messageId: messageId }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/cancel`,
            options: options
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools, optInSSEStream: optInSSEStream = false, storeMessage: storeMessage = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, aiFeatureContext: aiFeatureContext, agentVersion: agentVersion, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, capabilities: capabilities, searchArtifact: searchArtifact, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, useCurrentBrowsingContext: useCurrentBrowsingContext, browserContextSanitizer: browserContextSanitizer }) {
        const effectiveCapabilities = (0, $5suST.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        // browser_url is historically the current window location. The blocklist gates the page
        // browser context added under the `rovo-include-full-context-on-confirmed-tools`
        // experiment (when a browserContext is supplied). The NO-URL sentinel under the
        // `jira_free_gen_editor` experiment suppresses the URL (matching sendMessageStream) so that
        // cohort does not leak a URL.
        const browserUrl = browserContext?.context?.browserUrl;
        const isBrowserContextBlocklisted = !!(browserUrl && browserContextSanitizer?.isBlocklisted(browserUrl));
        const isBrowserUrlSuppressed = browserUrl === 'NO-URL' && (0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false);
        const url = isBrowserUrlSuppressed ? '' : window?.location?.href;
        const isBrowserSelectionContextGateEnabled = (0, $iDrrr.fg)('rovo_chat_browser_selection_context');
        const browserSelection = isBrowserSelectionContextGateEnabled ? browserContext?.context?.selection : undefined;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            confirmed_tools: confirmed_tools,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            context: {
                // Historical slim context — unchanged so the experiment-off request is byte-identical.
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                ...deepResearchEnabled ? {
                    deepResearchEnabled: deepResearchEnabled
                } : {},
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...aiFeatureContext ? {
                    aiFeatureContext: aiFeatureContext
                } : {},
                ...searchArtifact ? {
                    search_artifact: searchArtifact
                } : {},
                // Full request context — supplied by the store action only when the
                // `rovo-include-full-context-on-confirmed-tools` experiment is on, so the backend
                // receives the same page/whiteboard/creation context as a regular sendMessage.
                // Every field is omitted when undefined, so the slim request above is unaffected.
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                // Content-context objects. Inlined to mirror sendMessageStream's serialization
                // exactly; a unit test (the drift guard) asserts the two stay in sync. Each is
                // omitted when undefined, so the slim request above is unaffected.
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                ...browserContext && !isBrowserContextBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText,
                        ...browserSelection ? {
                            selection: browserSelection
                        } : {}
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            // don't allow store message if feature flag is off
            store_message: (0, $iDrrr.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId, capabilities) {
        // Forward the caller-provided chat capabilities (e.g. `inline_lumina_enabled`,
        // which is gated behind `rovo_chat_enable_inline_lumina`) so that fetching a
        // chat from history renders the same rich (Lumina) components as a live stream,
        // rather than downgrading to basic markdown.
        //
        // Note: this intentionally forwards `capabilities` as-is rather than routing
        // through `buildEffectiveCapabilities`. That helper fires the actionable
        // follow-ups experiment exposure, which must only happen when a message is
        // SENT — not when history is read — so reusing it here would pollute the
        // experiment and attach send-only capabilities to a read request.
        const headers = this.createHeaders({
            ...capabilities && capabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(capabilities)
            }
        });
        const options = {
            method: 'GET',
            headers: headers
        };
        const params = new URLSearchParams({
            shouldMergeA2UI: 'true'
        });
        const path = (0, $cha5E.expVal)('jira_ai_merging_a2ui_history', 'isEnabled', false) ? `/rovo/v1/chat/conversation/${conversationId}/messages?${params}` : `/rovo/v1/chat/conversation/${conversationId}/messages`;
        const rawChat = await this.fetchJson({
            path: path,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]-messages'
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>(0, $bxkJA.isHumanMessage)(message) ? message : (0, $bkEBw.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options,
            holdName: 'rovo-v1-agents-accountid-[identityAccountId]'
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async createConversationChannel(options) {
        const name = options && 'name' in options ? options.name : (0, $7td41.generateConversationName)();
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8',
                    [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat')
                }),
                body: JSON.stringify({
                    name: name,
                    dialogues: options?.dialogues ?? undefined,
                    tags: options?.tags,
                    agent_id: options?.agentId
                })
            },
            holdName: 'rovo-v1-chat-conversation'
        });
    }
    async getConversationChannels(options) {
        const searchParams = new URLSearchParams();
        if (options?.limit !== undefined) searchParams.set('limit', String(options.limit));
        if (options?.cursor !== undefined) searchParams.set('cursor', options.cursor);
        const queryString = searchParams.toString();
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations${queryString ? `?${queryString}` : ''}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'rovo-v1-chat-conversations'
        });
        // Transform snake_case fields to camelCase
        return {
            items: result.items.map((item)=>this.transformSnakeCaseToCamelCase(item)),
            hasNext: result.hasNext ?? false,
            cursor: result.cursor ?? null
        };
    }
    async getPinnedConversationSummary() {
        try {
            const result = await this.fetchJson({
                path: '/rovo/v1/chat/conversations/pinned-summary',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversations-pinned-summary'
            });
            return {
                pinnedCount: result.pinned_count ?? 0,
                maxPinnedConversations: result.max_pinned_conversations ?? 0
            };
        } catch (error) {
            // The endpoint not being deployed yet surfaces as a 404 — ignore that (callers fall back to
            // the local pinned count). Any other failure is genuine, so rethrow rather than swallow it
            // silently, letting the caller report/handle it.
            const statusCode = error instanceof (0, $8A2GO.ApiError) ? error.errorAttributes?.statusCode : undefined;
            if (statusCode === 404) return undefined;
            throw error;
        }
    }
    updateConversationChannel(id, payload) {
        // Transform camelCase field names to snake_case for the REST API
        const apiPayload = this.transformCamelCaseToSnakeCase(payload);
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(apiPayload)
            },
            holdName: 'rovo-v1-chat-conversation-[id]'
        }).then((response)=>this.transformSnakeCaseToCamelCase(response));
    }
    transformCamelCaseToSnakeCase(payload) {
        const result = {};
        for (const [key, value] of Object.entries(payload)){
            if (key === 'readStatus') result['read_status'] = value;
            else if (key === 'isPinned') result['is_pinned'] = value;
            else if (key === 'pinnedAt') result['pinned_at'] = value;
            else if (key === 'sourceMode') result['source_mode'] = value;
            else result[key] = value;
        }
        return result;
    }
    transformSnakeCaseToCamelCase(item) {
        if (item == null || typeof item !== 'object') throw new Error(`Expected an object from conversation channel API, got: ${typeof item}`);
        const result = {
            ...item
        };
        if ('read_status' in result) {
            result['readStatus'] = result['read_status'];
            delete result['read_status'];
        }
        if ('is_pinned' in result) {
            result['isPinned'] = result['is_pinned'];
            delete result['is_pinned'];
        }
        if ('pinned_at' in result) {
            result['pinnedAt'] = result['pinned_at'];
            delete result['pinned_at'];
        }
        if ('source_mode' in result) {
            result['sourceMode'] = result['source_mode'];
            delete result['source_mode'];
        }
        const agentSessionState = result['agent_session_state'];
        delete result['agent_session_state'];
        delete result['agentSessionState'];
        if ($a1ccb2b7a1450c9c$var$isAgentSessionState(agentSessionState)) result['agentSessionState'] = agentSessionState;
        else if (agentSessionState != null) (0, $hlvTd.logSentryConsoleWarning)('Unknown agent session state returned by conversation channel API:', agentSessionState);
        return result;
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            holdName: 'rovo-v1-chat-conversation-[id]-action'
        });
    }
    async bulkResolveConversationUIActions(conversationId, messageId, payload) {
        // The bulk API supports a maximum of 50 items per request.
        // Split into batches and process them sequentially.
        const BATCH_SIZE = 50;
        const allResponses = [];
        for(let batchStart = 0; batchStart < payload.items.length; batchStart += BATCH_SIZE){
            const batchItems = payload.items.slice(batchStart, batchStart + BATCH_SIZE);
            const batchResponses = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/tools/resolution`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        items: batchItems.map((item)=>({
                                ...item,
                                context: {
                                    ...item.context,
                                    browser_url: window.location.href
                                }
                            }))
                    })
                },
                holdName: 'rovo-v1-chat-conversation-[id]-message-[messageId]-tools-resolution'
            });
            allResponses.push(...batchResponses);
        }
        return allResponses;
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options,
            holdName: 'rovo-v1-conversation-starters-agent-starter-suggestion'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options,
            holdName: 'rovo-v1-conversation-starters-page-contextual'
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options,
            holdName: 'api-ai-v2-ai-feature-convo-starters'
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options,
            holdName: 'api-v2-configuration-web-search-ai'
        });
        return result;
    }
    async getPrompts() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
        return result;
    }
    async getPrompt(promptId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-[promptId]'
        });
    }
    async bulkGetPrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-get',
            options: options,
            holdName: 'api-v2-prompts-bulk-get'
        });
    }
    async createPrompt(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
    }
    async updatePrompt(promptId, payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-update'
        });
    }
    async addPromptsToLibrary(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: '/api/v2/prompts/add-to-library',
            options: options,
            holdName: 'api-v2-prompts-add-to-library'
        });
    }
    /**
   * Deletes a prompt from the library. `shareId` is the same value as `GetPromptResponse.id`, not a
   * second kind of identifier: `getPrompt`/`updatePrompt` call the identical value `promptId`, and
   * the client never holds any other prompt id. See the `deletePrompt` note on `AssistanceService`.
   */ async deletePrompt(shareId) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers
        };
        await this.fetch({
            path: `/api/v2/prompts/${shareId}`,
            options: options,
            holdName: 'api-v2-prompts-delete'
        });
    }
    async favoritePrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: `/api/v2/prompts/favorite`,
            options: options,
            holdName: 'api-v2-prompts-favorite'
        });
    }
    async bulkUpdatePrivacy(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-update-privacy',
            options: options,
            holdName: 'api-v2-prompts-bulk-update-privacy'
        });
    }
    async upsertConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-upsert'
        });
    }
    async ensureConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-ensure'
        });
    }
    async replaceConversationShare(payload) {
        const { conversationId: conversationId, messageId: messageId, shareType: shareType, allowedUserAris: allowedUserAris } = payload;
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        const body = {
            conversationId: conversationId,
            messageId: messageId,
            shareType: shareType,
            ...shareType === 'SPECIFIC_USERS' ? {
                allowedUserAris: allowedUserAris ?? []
            } : {}
        };
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(body)
        };
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: options,
            holdName: 'api-v2-share-replace'
        });
    }
    async getConversationShare(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-get'
        });
    }
    async getConversationShareMetadata({ conversationId: conversationId, messageId: messageId }) {
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-metadata-get'
        });
    }
    async getConversationSharePreview({ conversationId: conversationId, messageId: messageId }) {
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        return this.fetchJson({
            path: `/api/v2/share/preview?${query.toString()}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-preview-get'
        });
    }
    async forkSharedConversation(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}/fork`,
            options: {
                method: 'POST',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-fork'
        });
    }
    async deleteConversationShare(shareToken) {
        await this.fetch({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'DELETE',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-delete'
        });
    }
    async deleteAllSharesForConversation(conversationId) {
        await this.fetch({
            path: `/api/v2/shares/conversation/${encodeURIComponent(conversationId)}`,
            options: {
                method: 'DELETE',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-shares-conversation-delete'
        });
    }
    constructor(props){
        super(props);
        // Defined as an arrow property so `this` stays bound when the reference is
        // passed directly to data-fetching hooks (e.g. useQuery's queryFn).
        this.getGroupedConversationShares = async ()=>{
            return this.fetchJson({
                path: '/api/v2/shares/grouped',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'api-v2-shares-grouped-get'
            });
        };
        this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-actions'
            });
            return response.actions;
        };
        this.getAgentKnowledgeConfiguration = (agentCreatorType)=>{
            const queryParams = agentCreatorType ? `?agentCreatorType=${agentCreatorType}` : '';
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge${queryParams}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-knowledge'
            });
        };
        this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v2-permissions-agents-[agentId]'
            });
        };
        this.getRecommendedAgents = ({ limit: limit, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString()
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-recommend-v2'
            });
        };
        this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]-debug-logs'
            });
            return response.items;
        };
        this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: this.config.fileValidatePath ?? $a1ccb2b7a1450c9c$var$DEFAULT_FILE_VALIDATE_PATH,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-message-file-validate'
            });
        };
        this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: this.config.fileUploadPath ?? $a1ccb2b7a1450c9c$var$DEFAULT_FILE_UPLOAD_PATH,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                },
                holdName: 'rovo-v1-chat-message-file'
            });
            return response;
        };
        this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-agent-playground-chat-stream'
            });
        };
        this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-chat-conversations'
            });
        };
        this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-tools'
            });
        };
        this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-language-models'
            });
        };
        this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-prompts'
            });
        };
        this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-generated-content'
            });
        };
        this.getRovoUserSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.updateRovoUserSettings = async (settings)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(settings)
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.getRovoMemories = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories'
            });
        };
        this.getRovoMemoryBlurb = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/blurb',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-blurb'
            });
        };
        this.answerNow = async (conversationId, messageId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/answer-now`,
                options: options,
                holdName: 'rovo-v1-chat-conversation-message-answer-now'
            });
        };
        this.deleteRovoMemory = async (memoryId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/${memoryId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-[memoryId]'
            });
        };
        this.getRovoMemoryEdits = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        };
        this.createMemoryEdit = async (payload)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        };
        this.createMemory = async (payload)=>{
            await this.fetch({
                path: '/rovo/v1/chat/memories/create',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-create'
            });
        };
        this.getRovoMemoryEditsCount = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits/count',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits-count'
            });
        };
        this.deleteRovoMemoryEdit = async (editId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/memory-edits/${editId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-memory-edits-[editId]'
            });
        };
        this.fetchConversationMetadata = async (conversationId)=>{
            const result = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]'
            });
            return this.transformSnakeCaseToCamelCase(result);
        };
        this.fetchPersonalizedPromptSuggestions = async (config)=>{
            const { offset: offset = 0, limit: limit = 9, contentType: contentType, entryPoint: entryPoint } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit,
                        ...contentType ? {
                            contentType: contentType
                        } : {},
                        ...entryPoint ? {
                            entryPoint: entryPoint
                        } : {}
                    }
                })
            };
            const result = await this.fetchJson({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles'
            });
            return result?.ai_feature_output?.prompt_tiles ?? [];
        };
        this.getTasks = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $a1ccb2b7a1450c9c$var$TASKS_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            return this.fetchJson({
                path: `/rovo/v1/tasks?${searchParams.toString()}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-tasks'
            });
        };
        this.getLibraryEntries = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $a1ccb2b7a1450c9c$var$LIBRARY_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            const options = {
                method: 'GET',
                headers: this.createHeaders(),
                signal: params?.controller?.signal
            };
            return this.fetchJson({
                baseUrl: $a1ccb2b7a1450c9c$var$GATEWAY_BASE_URL,
                path: `/rovo-chat/v1/library?${searchParams.toString()}`,
                options: options,
                holdName: 'rovo-chat-v1-library'
            });
        };
        this.getTasksStream = async (controller)=>{
            return this.fetchStream({
                path: '/rovo/v1/tasks/stream',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        Accept: 'text/event-stream'
                    }),
                    signal: controller?.signal
                },
                holdName: 'rovo-v1-tasks-stream'
            }, {
                useSSE: true
            });
        };
        this.cancelTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}/cancel`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-cancel'
            });
        };
        this.deleteTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-delete'
            });
        };
        this.renameTask = async (taskId, title)=>{
            return this.fetchJson({
                path: `/rovo/v1/tasks/${taskId}`,
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        title: title
                    })
                },
                holdName: 'rovo-v1-tasks-[taskId]'
            });
        };
        this.fetchPersonalizedPromptSuggestionsStream = async (config)=>{
            const { offset: offset = 0, limit: limit = 9, contentType: contentType, entryPoint: entryPoint, enable3pPrompt: enable3pPrompt } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit,
                        ...contentType ? {
                            contentType: contentType
                        } : {},
                        ...entryPoint ? {
                            entryPoint: entryPoint
                        } : {},
                        // Only sent for experiment variants A/B; omitted for everyone else so the
                        // request is byte-identical to the pre-3P-feature request.
                        ...enable3pPrompt ? {
                            enable_3p_prompt: true
                        } : {}
                    }
                })
            };
            return this.fetchStream({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles/stream',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles-stream'
            });
        };
    }
}
const $a1ccb2b7a1450c9c$var$AssistanceServiceContext = /*#__PURE__*/ (0, $cozmU.createContext)(new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $a1ccb2b7a1450c9c$export$8fe647eb935c33db = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { value: value, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ccb2b7a1450c9c$var$AssistanceServiceContext.Provider, {
            value: value
        }, children);
        $[0] = children;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ value: value, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ccb2b7a1450c9c$var$AssistanceServiceContext.Provider, {
        value: value
    }, children);
const $a1ccb2b7a1450c9c$export$7e31a1844ebbaf85 = (props)=>{
    (0, $6cFsl.di)((0, $cozmU.useContext), $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94);
    const service = (0, $cozmU.useContext)($a1ccb2b7a1450c9c$var$AssistanceServiceContext);
    (0, $7zss8.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers && !props.channelId) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    const channelId = props.channelId ?? service.getConfig().channelId;
    return new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers,
        channelId: channelId
    });
};
const $a1ccb2b7a1450c9c$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $6cFsl.di)($a1ccb2b7a1450c9c$export$a522c5f4ccda1c94, (0, $bjY3F.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $cozmU.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $cozmU.useMemo)(()=>{
            return new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                channelId: assistanceServiceParams.channelId,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias,
                fileValidatePath: assistanceServiceParams.fileValidatePath,
                fileUploadPath: assistanceServiceParams.fileUploadPath
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            assistanceServiceParams.channelId,
            headers,
            assistanceServiceParams.minionAlias,
            assistanceServiceParams.fileValidatePath,
            assistanceServiceParams.fileUploadPath
        ]);
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing assistance-service baseline: injected hook params are adapted to the generic hook parameter type.
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};
module.exports["AssistanceServiceBase"] = $a1ccb2b7a1450c9c$export$40a7802808e2fbe3;
module.exports["AssistanceServiceImpl"] = $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94;
module.exports["AssistanceServiceProvider"] = $a1ccb2b7a1450c9c$export$8fe647eb935c33db;
module.exports["useAssistanceService"] = $a1ccb2b7a1450c9c$export$7e31a1844ebbaf85;
module.exports["createHookWithAssistanceService"] = $a1ccb2b7a1450c9c$export$5a9ea20fc196ec62;

});

parcelRegister("bjY3F", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $6cFsl = parcelRequire("6cFsl");


var $1hQ0e = parcelRequire("1hQ0e");


var $cXtTj = parcelRequire("cXtTj");


var $a33Aa = parcelRequire("a33Aa");


var $boaiH = parcelRequire("boaiH");


var $10XTN = parcelRequire("10XTN");


var $hlvTd = parcelRequire("hlvTd");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $irnO2 = parcelRequire("irnO2");


var $1XM8n = parcelRequire("1XM8n");


var $8YL3U = parcelRequire("8YL3U");

var $78cafaa44d513db0$var$_ExperienceTrackerHandler;
const $78cafaa44d513db0$var$isRovoInstrumentedError = (error)=>error !== null && error !== undefined && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
const $78cafaa44d513db0$var$isTerminalEvent = (event)=>event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort';
const $78cafaa44d513db0$var$isAbortEvent = (event)=>event.action === 'taskAbort';
class $78cafaa44d513db0$export$5a92a056565f01cc {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$78cafaa44d513db0$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $cXtTj.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $78cafaa44d513db0$export$5a92a056565f01cc.instance = new $78cafaa44d513db0$export$5a92a056565f01cc(dropEvents);
        }
        // instance is guaranteed to be set after the guard above
        return $78cafaa44d513db0$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $78cafaa44d513db0$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $78cafaa44d513db0$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $boaiH.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.tabVisibilityByExperience = new Map();
        const doc = (0, $1hQ0e.getDocument)();
        if (doc) (0, $cbY7C.bind)(doc, {
            type: 'visibilitychange',
            listener: ()=>{
                const isHidden = doc.visibilityState === 'hidden';
                this.tabVisibilityByExperience.forEach((tracker)=>{
                    tracker.onVisibilityChange(isHidden);
                });
            }
        });
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            if (event.action === 'taskStart') this.tabVisibilityByExperience.set(event.name, new (0, $8YL3U.TabVisibilityTracker)(doc));
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // When non-null, converts taskFail → taskAbort so the error is excluded from SLO
            // failure counts but still recorded for anomaly detection purposes.
            let sloExclusion = null;
            const isErrorEvent = 'error' in event;
            // Skip SLO exclusion logic for the aiMateFilteredClientError experience itself
            // to avoid re-processing and potential infinite loops.
            const isFilteredClientErrorExperience = event.name === (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR;
            if (isErrorEvent && !isFilteredClientErrorExperience) {
                // Classify common non-service errors so they can be tracked separately from
                // real backend failures:
                //   - client fetch errors (e.g. "Failed to fetch") — request never reached Atlassian
                //   - product-not-active — HTTP 200 but SSE payload contains an errorCode
                //   - auth/permission — HTTP 401/403 (session expired, HIPAA, IP allowlist, etc.)
                if ((0, $10XTN.isClientFetchError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).CLIENT_FETCH_ERROR
                    };
                } else if ((0, $10XTN.isProductNotActiveError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).PRODUCT_NOT_ACTIVE
                    };
                } else if ((0, $10XTN.isAuthOrPermissionError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).AUTH_OR_PERMISSION_ERROR
                    };
                } else if ((0, $10XTN.isRateLimitError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).RATE_LIMIT_ERROR
                    };
                }
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        fastModeEnabled: fastModeEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($78cafaa44d513db0$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                const teamName = (0, $1XM8n.getOwningTeam)(event.error.message ?? '', event.name);
                filteredErrorAttributes = {
                    teamName: teamName,
                    // We intentionally put this first so a `teamName` attribute can override this.
                    ...filteredErrorAttributes
                };
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = typeof attributes?.touchpointSource === 'string' ? attributes.touchpointSource : undefined;
                    const teamName = typeof attributes?.teamName === 'string' ? attributes.teamName : undefined;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $hlvTd.logException)({
                        exception: error,
                        name: event.name,
                        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing experience-tracker baseline: legacy UFO attributes are assembled from mixed attribute sources before being passed to a string map API.
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if ($78cafaa44d513db0$var$isTerminalEvent(event)) // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $a33Aa.addSpanToAll)('custom', `exp-${event.name}`, $78cafaa44d513db0$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            const tabVisibilityAttributes = $78cafaa44d513db0$var$isTerminalEvent(event) ? this.tabVisibilityByExperience.get(event.name)?.getAttributes(doc) ?? {} : {};
            // If the error should be excluded from SLO, report it as taskAbort instead of taskFail.
            // taskAbort events are not counted as failures in the SLO but are still recorded
            // so anomaly detectors can track spikes in these error types.
            const effectiveAction = sloExclusion && event.action === 'taskFail' ? 'taskAbort' : event.action;
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: effectiveAction,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...$78cafaa44d513db0$var$isTerminalEvent(event) && {
                        duration: event.duration
                    },
                    // Include error info on both taskFail and taskAbort (for excluded errors)
                    // so analytics/anomaly detectors can distinguish error types.
                    ...isErrorEvent && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    // Surface why the error was excluded from the SLO so the raw analytics
                    // event can be queried/grouped without joining to the synthetic experience.
                    ...sloExclusion && {
                        sloExclusionReason: sloExclusion.reason
                    },
                    // `abort()` takes its reason as a top-level field rather than inside
                    // `attributes`, so it is otherwise dropped here and aborts land in
                    // analytics with no indication of why they happened. Spread before
                    // `event.attributes` so callers that already nest their own `reason`
                    // keep precedence.
                    ...$78cafaa44d513db0$var$isAbortEvent(event) && {
                        reason: event.reason
                    },
                    ...event.attributes,
                    ...tabVisibilityAttributes
                }
            }, {
                removeDefaultTags: true
            });
            // When a client error is excluded from the main SLO (ie. converted to taskAbort),
            // track a separate experience so the volume of these errors can be monitored with its own SLO threshold.
            if (sloExclusion && isErrorEvent) {
                this.experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    id: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    startTime: event.startTime
                });
                this.experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    error: event.error,
                    attributes: {
                        // Preserve the original experience name, error, and exclusion reason for queryability
                        originalTask: event.name,
                        error: event.error.message,
                        sloExclusionReason: sloExclusion.reason,
                        ...filteredErrorAttributes
                    }
                });
            }
            if ($78cafaa44d513db0$var$isTerminalEvent(event)) this.tabVisibilityByExperience.delete(event.name);
        });
    }
}
$78cafaa44d513db0$var$_ExperienceTrackerHandler = $78cafaa44d513db0$export$5a92a056565f01cc;
$78cafaa44d513db0$export$5a92a056565f01cc.instance = void 0;
$78cafaa44d513db0$export$5a92a056565f01cc.labelStack = [];
const $78cafaa44d513db0$export$63af6e7bbb4f375d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $78cafaa44d513db0$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((componentLabelStack)=>{
        $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $78cafaa44d513db0$export$412c53791574f6f0 = (params)=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useMemo)(()=>{
        const experienceTracker = $78cafaa44d513db0$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $cozmU.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        name: failParams.name,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($78cafaa44d513db0$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource
    ]);
    return experienceTrackerProxy;
};
function $78cafaa44d513db0$var$_temp(componentLabelStack) {
    $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
}
module.exports["ExperienceTrackerHandler"] = $78cafaa44d513db0$export$5a92a056565f01cc;
module.exports["useUFOLabelStackSetter"] = $78cafaa44d513db0$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $78cafaa44d513db0$export$412c53791574f6f0;

});

parcelRegister("10XTN", function(module, exports) {

var $3PJhM = parcelRequire("3PJhM");

// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Load failed',
    // Safari equivalent of "Failed to fetch"
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $ab109556016fa76e$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $ab109556016fa76e$var$MAX_ERROR_CAUSE_DEPTH = 3;
const $ab109556016fa76e$var$getErrorAndCauseRecords = (error)=>{
    const records = [];
    let currentError = error;
    for(let depth = 0; depth < $ab109556016fa76e$var$MAX_ERROR_CAUSE_DEPTH && (0, $3PJhM.isRecord)(currentError); depth++){
        records.push(currentError);
        currentError = currentError.cause;
    }
    return records;
};
const $ab109556016fa76e$var$getErrorStatusCode = (error)=>{
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const attributes = (0, $3PJhM.isRecord)(error.attributes) ? error.attributes : undefined;
    const status = errorAttributes?.statusCode ?? error.status ?? attributes?.status;
    return typeof status === 'number' ? status : undefined;
};
const $ab109556016fa76e$var$getErrorCode = (error)=>{
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    return typeof errorAttributes?.errorCode === 'string' ? errorAttributes.errorCode.toLowerCase() : undefined;
};
const $ab109556016fa76e$export$2e7adc44463c3f4f = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return false;
    // Check top-level error name and message
    const hasKnownName = typeof error.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name);
    const hasKnownMessage = typeof error.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.message);
    if (hasKnownName || hasKnownMessage) return true;
    // Also check the nested cause (e.g. wrapped fetch errors)
    if (!(0, $3PJhM.isRecord)(error.cause)) return false;
    return typeof error.cause.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || typeof error.cause.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.cause.message);
};
const $ab109556016fa76e$export$de229d5c9394f905 = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const status = $ab109556016fa76e$var$getErrorStatusCode(errorRecord);
        return status === 401 || status === 403;
    });
};
const $ab109556016fa76e$export$a8908c3867f6f20b = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>$ab109556016fa76e$var$getErrorStatusCode(errorRecord) === 429);
};
const $ab109556016fa76e$export$9f0dca42eff14720 = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const errorCode = $ab109556016fa76e$var$getErrorCode(errorRecord) ?? '';
        return errorCode.includes('product.not.active') || errorCode.includes('product_not_active');
    });
};
module.exports["isClientFetchError"] = $ab109556016fa76e$export$2e7adc44463c3f4f;
module.exports["isAuthOrPermissionError"] = $ab109556016fa76e$export$de229d5c9394f905;
module.exports["isRateLimitError"] = $ab109556016fa76e$export$a8908c3867f6f20b;
module.exports["isProductNotActiveError"] = $ab109556016fa76e$export$9f0dca42eff14720;

});

parcelRegister("3PJhM", function(module, exports) {
/**
 * Type guard that checks whether a value is a plain record object.
 */ const $99d6458d8ffffa8f$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
module.exports["isRecord"] = $99d6458d8ffffa8f$export$6ba840931da50680;

});

parcelRegister("hlvTd", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $jTKfH = parcelRequire("jTKfH");


var $10XTN = parcelRequire("10XTN");


var $cj7GQ = parcelRequire("cj7GQ");


var $8DeC3 = parcelRequire("8DeC3");


var $2AFxF = parcelRequire("2AFxF");


var $fPSAz = parcelRequire("fPSAz");


// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $024249913f1d8b5b$var$importLegacySentryAsync = async ()=>Promise.resolve((parcelRequire("eieXD")));

const $024249913f1d8b5b$var$importPrivateSentryAsync = async ()=>{
    const sentry = await Promise.resolve((parcelRequire("eieXD")));
    return {
        BrowserClient: sentry.BrowserClient,
        eventFromException: sentry.eventFromException
    };
};
const $024249913f1d8b5b$var$DEFAULT_PACKAGE_NAME = '@atlassian/conversation-assistant';
const $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
const $024249913f1d8b5b$var$KNOWN_NON_PRODUCTION_LOCATION_PARTS = [
    'localhost',
    '.local',
    'jira-dev.com',
    'stg.atlassian.com',
    'stg.internal.atlassian.com',
    'stg-east.frontend.public.atl-paas.net'
];
let $024249913f1d8b5b$var$sentryClient;
let $024249913f1d8b5b$var$privateReporter;
let $024249913f1d8b5b$var$selectedReportingPipeline;
const $024249913f1d8b5b$var$reportingPipelineSelector = (0, $2AFxF.createPageSessionReportingPipelineSelector)(()=>(0, $iDrrr.fg)('rovo_chat_sentry_isolated_reporter'));
let $024249913f1d8b5b$var$sentrySetupFailed = false;
let $024249913f1d8b5b$var$sentrySetupFailure;
// Report the irrecoverable setup failure once per page session. The underlying mismatch cannot
// recover until the host reloads with compatible Sentry versions.
let $024249913f1d8b5b$var$sentrySetupFailureReported = false;
let $024249913f1d8b5b$var$accountIdPromise;
const $024249913f1d8b5b$var$defaultAccountIdProvider = ()=>new Promise((resolve, reject)=>{
        (0, $jTKfH.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        }).then((profileData)=>{
            if (profileData?.account_id) resolve(profileData.account_id);
            else reject(new Error('Profile data not loaded'));
        }).catch((error)=>{
            reject(error);
        });
    });
let $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
const $024249913f1d8b5b$export$59333a3d3d770a30 = (fn)=>{
    $024249913f1d8b5b$var$accountIdProvider = fn;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$e941c8ce80d1ac70 = ()=>{
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$388db6ab9ccbe151 = ()=>{
    $024249913f1d8b5b$var$privateReporter?.resetForTests();
    $024249913f1d8b5b$var$sentryClient = undefined;
    $024249913f1d8b5b$var$privateReporter = undefined;
    $024249913f1d8b5b$var$selectedReportingPipeline = undefined;
    $024249913f1d8b5b$var$reportingPipelineSelector.resetForTests();
    $024249913f1d8b5b$var$sentrySetupFailed = false;
    $024249913f1d8b5b$var$sentrySetupFailure = undefined;
    $024249913f1d8b5b$var$sentrySetupFailureReported = false;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
};
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $024249913f1d8b5b$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $024249913f1d8b5b$var$getEnvironment = ()=>{
    return 'production';
};
const $024249913f1d8b5b$var$getReportingPipeline = ()=>{
    if (!$024249913f1d8b5b$var$selectedReportingPipeline) $024249913f1d8b5b$var$selectedReportingPipeline = $024249913f1d8b5b$var$reportingPipelineSelector.get();
    return $024249913f1d8b5b$var$selectedReportingPipeline;
};
const $024249913f1d8b5b$export$2cf018785da78e5 = ()=>$024249913f1d8b5b$var$getReportingPipeline() === 'isolatedPrivateV1';
const $024249913f1d8b5b$var$getRelease = ()=>{
    if (typeof window === 'undefined') return;
    return window.SENTRY_RELEASE?.id;
};
const $024249913f1d8b5b$var$setupPrivateReporter = async ({ accountId: accountId, customSentryDsn: customSentryDsn, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product })=>{
    const dsn = customSentryDsn || $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN;
    if ($024249913f1d8b5b$var$privateReporter) {
        $024249913f1d8b5b$var$privateReporter.updateContext({
            accountId: accountId,
            packageVersion: packageVersion,
            product: product
        });
        return;
    }
    try {
        const importedSentry = await $024249913f1d8b5b$var$importPrivateSentryAsync();
        $024249913f1d8b5b$var$privateReporter = new (0, $8DeC3.ConversationAssistantPrivateReporter)({
            accountId: accountId,
            dsn: dsn,
            environment: $024249913f1d8b5b$var$getEnvironment(),
            ignoreErrors: ignoreErrors,
            packageName: packageName,
            packageVersion: packageVersion,
            product: product,
            release: $024249913f1d8b5b$var$getRelease(),
            sentry: importedSentry
        });
    } catch  {
    // Private reporting is best effort and must not affect Sentry callers.
    }
};
const $024249913f1d8b5b$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion, onSetupFailure: onSetupFailure } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $cj7GQ.getRovoChatProduct)();
    const resolvedPackageName = packageName || $024249913f1d8b5b$var$DEFAULT_PACKAGE_NAME;
    if ($024249913f1d8b5b$var$getReportingPipeline() === 'legacyGlobal' && $024249913f1d8b5b$var$sentrySetupFailed) {
        $024249913f1d8b5b$var$reportSentrySetupFailure(onSetupFailure);
        return;
    }
    try {
        if (!$024249913f1d8b5b$var$accountIdPromise) $024249913f1d8b5b$var$accountIdPromise = $024249913f1d8b5b$var$accountIdProvider();
        accountId = await $024249913f1d8b5b$var$accountIdPromise;
    } catch  {
    // do nothing
    }
    if ($024249913f1d8b5b$export$2cf018785da78e5()) {
        await $024249913f1d8b5b$var$setupPrivateReporter({
            accountId: accountId,
            customSentryDsn: customSentryDsn,
            ignoreErrors: ignoreErrors,
            packageName: resolvedPackageName,
            packageVersion: packageVersion,
            product: product
        });
        return;
    }
    if ($024249913f1d8b5b$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $024249913f1d8b5b$var$sentryClient.setTag('product', product);
        $024249913f1d8b5b$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $024249913f1d8b5b$var$importLegacySentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    const shouldSuppressSetupRetry = (0, $iDrrr.fg)('rovo_chat_sentry_setup_retry_killswitch');
    try {
        importedSentry.init({
            dsn: customSentryDsn || $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN,
            environment: $024249913f1d8b5b$var$getEnvironment(),
            integrations: (integrations)=>{
                return integrations.filter((integration)=>{
                    return $024249913f1d8b5b$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
                });
            },
            initialScope: {
                user: {
                    id: accountId
                },
                tags: {
                    packageName: resolvedPackageName,
                    product: product,
                    packageVersion: packageVersion
                }
            },
            // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
            beforeSend: (event, hint)=>{
                const exception = hint?.originalException;
                // Ignore network-like errors
                if ((0, $10XTN.isClientFetchError)(exception)) return null;
                if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
                // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
                return null;
                let updatedEvent = event;
                if (updatedEvent.request?.url) {
                    // Ignore events from localhost and staging
                    if ($024249913f1d8b5b$var$KNOWN_NON_PRODUCTION_LOCATION_PARTS.some((part)=>updatedEvent.request?.url?.includes(part))) return null;
                    updatedEvent.request.url = (0, $fPSAz.normaliseUrl)(updatedEvent.request.url);
                }
                if (updatedEvent.exception?.values) {
                    const allMatchedUUIDs = [];
                    updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                        const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $fPSAz.normalizeUUID)(exception.value);
                        allMatchedUUIDs.push(...matchedUUIDs);
                        return {
                            ...exception,
                            value: normalized
                        };
                    });
                    if (allMatchedUUIDs.length > 0) {
                        if (!updatedEvent.tags) updatedEvent.tags = {};
                        updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                    }
                }
                return updatedEvent;
            },
            attachStacktrace: true,
            ignoreErrors: ignoreErrors
        });
        $024249913f1d8b5b$var$sentryClient = importedSentry;
    } catch (error) {
        // this function throws e.update is not a function errors when we have a mismatch in sentry versions.
        // all targeted errors include 'update is not a function' even if minified differently
        if (error instanceof Error && error.message.includes('update is not a function')) {
            // Instead of throwing and logging the error to sentry, swallow it.
            if (shouldSuppressSetupRetry) {
                $024249913f1d8b5b$var$sentrySetupFailure = {
                    reason: 'sentry_version_mismatch',
                    product: product,
                    packageName: resolvedPackageName,
                    setupRetrySuppressed: true
                };
                $024249913f1d8b5b$var$reportSentrySetupFailure(onSetupFailure);
                $024249913f1d8b5b$var$sentrySetupFailed = true;
            } else $024249913f1d8b5b$var$sentryClient = importedSentry;
        } else throw error;
    }
};
const $024249913f1d8b5b$var$reportSentrySetupFailure = (onSetupFailure)=>{
    if (!onSetupFailure || !$024249913f1d8b5b$var$sentrySetupFailure || $024249913f1d8b5b$var$sentrySetupFailureReported) return;
    $024249913f1d8b5b$var$sentrySetupFailureReported = true;
    try {
        onSetupFailure($024249913f1d8b5b$var$sentrySetupFailure);
    } catch  {
    // Setup failure telemetry is best effort and must not break Sentry callers.
    }
};
const $024249913f1d8b5b$var$getSentryClient = async ()=>{
    if (!$024249913f1d8b5b$var$sentryClient && !$024249913f1d8b5b$var$sentrySetupFailed) // this only happens if something using sentry before the initialisation in root app
    await $024249913f1d8b5b$export$d8bd0edf6c978788();
    return $024249913f1d8b5b$var$sentryClient;
};
const $024249913f1d8b5b$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    if ($024249913f1d8b5b$export$2cf018785da78e5()) {
        if (!$024249913f1d8b5b$var$privateReporter) await $024249913f1d8b5b$export$d8bd0edf6c978788();
        try {
            await $024249913f1d8b5b$var$privateReporter?.captureException({
                exception: exception,
                name: name,
                tags: tags
            });
        } catch  {
        // Private reporting is best effort and must not affect Sentry callers.
        }
        return;
    }
    const sentryClient = await $024249913f1d8b5b$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') scope.setTag('experience', name);
        try {
            sentryClient.captureException(exception, scope);
        } catch (error) {
        // this function throws e.update is not a function errors when we have a mismatch in sentry versions. Instead of throwing and logging the error to sentry, swallow it.
        // TODO: upgrade sentry across confluence, jira, etc. to the same version to avoid this error
        }
    });
};
async function $024249913f1d8b5b$export$de29810e0b4aa46e(crumb) {
    if ($024249913f1d8b5b$export$2cf018785da78e5()) {
        if (!$024249913f1d8b5b$var$privateReporter) await $024249913f1d8b5b$export$d8bd0edf6c978788();
        try {
            $024249913f1d8b5b$var$privateReporter?.addBreadcrumb(crumb);
        } catch  {
        // Breadcrumb collection is best effort and must never affect the caller.
        }
        return;
    }
    const sentryClient = await $024249913f1d8b5b$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.addBreadcrumb !== 'function') return;
    sentryClient.addBreadcrumb(typeof crumb === 'string' ? {
        message: crumb
    } : crumb);
}
const $024249913f1d8b5b$export$2a10cc65cb1c6167 = (...args)=>{
    console.error(...args); // eslint-disable-line no-console
    if ($024249913f1d8b5b$export$2cf018785da78e5() && $024249913f1d8b5b$var$privateReporter) try {
        $024249913f1d8b5b$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'error',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
const $024249913f1d8b5b$export$b9f335638bb5225f = (...args)=>{
    console.warn(...args); // eslint-disable-line no-console
    if ($024249913f1d8b5b$export$2cf018785da78e5() && $024249913f1d8b5b$var$privateReporter) try {
        $024249913f1d8b5b$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'warning',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
module.exports["isIsolatedSentryReportingSelected"] = $024249913f1d8b5b$export$2cf018785da78e5;
module.exports["setupSentryClient"] = $024249913f1d8b5b$export$d8bd0edf6c978788;
module.exports["logException"] = $024249913f1d8b5b$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $024249913f1d8b5b$export$de29810e0b4aa46e;
module.exports["logSentryConsoleError"] = $024249913f1d8b5b$export$2a10cc65cb1c6167;
module.exports["logSentryConsoleWarning"] = $024249913f1d8b5b$export$b9f335638bb5225f;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("cj7GQ", function(module, exports) {
const $cfb262a7d2b032b8$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    const win = window;
    if (win.__ROVO_CHAT_CONFIG_PRODUCT__) product = win.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $cfb262a7d2b032b8$export$d4fdfa93c283ffc;

});

parcelRegister("8DeC3", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");


var $10XTN = parcelRequire("10XTN");


var $u3ka6 = parcelRequire("u3ka6");


var $fPSAz = parcelRequire("fPSAz");

const $0e0107334ae89504$var$MAX_LINKED_ERRORS = 5;
const $0e0107334ae89504$var$MAX_MATCHED_UUID_TAG_LENGTH = 200;
const $0e0107334ae89504$var$BLOCKED_LOCATION_PARTS = [
    'localhost',
    'jira-dev.com',
    'stg.atlassian.com',
    'stg.internal.atlassian.com',
    'stg-east.frontend.public.atl-paas.net'
];
const $0e0107334ae89504$var$eventId = ()=>crypto.randomUUID().replace(/-/g, '');
const $0e0107334ae89504$var$matchesIgnorePattern = (value, patterns)=>patterns?.some((pattern)=>typeof pattern === 'string' ? value.includes(pattern) : (()=>{
            pattern.lastIndex = 0;
            const matches = pattern.test(value);
            pattern.lastIndex = 0;
            return matches;
        })()) ?? false;
const $0e0107334ae89504$var$isBlockedLocation = ()=>{
    if (typeof window === 'undefined') return false;
    return $0e0107334ae89504$var$BLOCKED_LOCATION_PARTS.some((part)=>window.location.href.includes(part));
};
const $0e0107334ae89504$var$requestObservationToBreadcrumb = (observation)=>({
        category: observation.kind === 'graphql' ? 'conversation-assistant.request.graphql' : 'conversation-assistant.request.http',
        data: observation,
        level: observation.outcome === 'success' || observation.outcome === 'abort' ? 'info' : 'warning',
        message: observation.kind === 'graphql' ? `${observation.operation} ${observation.outcome}` : `${observation.method} ${observation.route} ${observation.outcome}`,
        type: 'http'
    });
const $0e0107334ae89504$var$toPrivateBreadcrumb = (breadcrumb)=>({
        ...breadcrumb,
        level: breadcrumb.level
    });
const $0e0107334ae89504$var$getCause = (error)=>{
    const cause = error.cause;
    return cause instanceof Error ? cause : undefined;
};
class $0e0107334ae89504$export$7c63502cdfeff038 {
    updateContext({ accountId: accountId, packageVersion: packageVersion, product: product }) {
        this.accountId = accountId;
        if (this.packageVersion === undefined && packageVersion !== undefined) this.packageVersion = packageVersion;
        this.product = product;
    }
    addBreadcrumb(crumb) {
        this.breadcrumbGateway.add(crumb);
    }
    async captureException({ exception: exception, name: name, tags: tags }) {
        if (!this.enabled || (0, $10XTN.isClientFetchError)(exception) || $0e0107334ae89504$var$isBlockedLocation()) return;
        const rootMessage = exception instanceof Error ? exception.message : String(exception);
        if ($0e0107334ae89504$var$matchesIgnorePattern(rootMessage, this.ignoreErrors)) return;
        const id = $0e0107334ae89504$var$eventId();
        const event = await this.sentry.eventFromException(exception, {
            event_id: id
        }, true);
        await this.addLinkedErrors(event, exception);
        const eventTags = {
            experience: tags?.source === 'aiMateExperienceTracker' ? name : undefined,
            name: name,
            packageName: this.packageName,
            packageVersion: this.packageVersion,
            product: this.product,
            reportingPipeline: 'isolatedPrivateV1',
            sentryOwner: 'conversation-assistant',
            ...tags
        };
        event.tags = {
            ...event.tags,
            ...eventTags
        };
        event.user = {
            id: this.accountId
        };
        event.breadcrumbs = this.breadcrumbGateway.snapshot().map($0e0107334ae89504$var$toPrivateBreadcrumb);
        if (typeof window !== 'undefined') event.request = {
            ...event.request,
            url: (0, $fPSAz.normaliseUrl)(window.location.href)
        };
        this.normalizeEventUUIDs(event);
        // Do not pass `originalException`: BaseClient otherwise consults the SDK-wide
        // already-caught registry shared through Sentry's global carrier.
        this.client.captureEvent(event, {
            event_id: id
        });
    }
    resetForTests() {
        this.unsubscribeFromRequestObservations();
        this.breadcrumbGateway.reset();
    }
    async addLinkedErrors(event, exception) {
        if (!(exception instanceof Error) || !event.exception?.values) return;
        const linkedValues = [];
        let current = $0e0107334ae89504$var$getCause(exception);
        const seen = new Set([
            exception
        ]);
        while(current && linkedValues.length < $0e0107334ae89504$var$MAX_LINKED_ERRORS - 1 && !seen.has(current)){
            seen.add(current);
            const linkedEvent = await this.sentry.eventFromException(current, undefined, true);
            if (linkedEvent.exception?.values?.[0]) linkedValues.unshift(linkedEvent.exception.values[0]);
            current = $0e0107334ae89504$var$getCause(current);
        }
        event.exception.values = [
            ...linkedValues,
            ...event.exception.values
        ];
    }
    normalizeEventUUIDs(event) {
        if (!event.exception?.values) return;
        const matchedUUIDs = new Set();
        event.exception.values = event.exception.values.map((exceptionValue)=>{
            const { normalized: normalized, matchedUUIDs: matches } = (0, $fPSAz.normalizeUUID)(exceptionValue.value);
            matches.forEach((match)=>matchedUUIDs.add(match));
            return {
                ...exceptionValue,
                stacktrace: exceptionValue.stacktrace ? {
                    ...exceptionValue.stacktrace,
                    frames: exceptionValue.stacktrace.frames?.map((frame)=>{
                        const normalizedFrame = {
                            ...frame
                        };
                        [
                            'abs_path',
                            'filename',
                            'function',
                            'module'
                        ].forEach((key)=>{
                            if (typeof normalizedFrame[key] !== 'string') return;
                            const normalizedStackValue = (0, $fPSAz.normalizeUUID)(normalizedFrame[key]);
                            normalizedStackValue.matchedUUIDs.forEach((match)=>matchedUUIDs.add(match));
                            normalizedFrame[key] = normalizedStackValue.normalized;
                        });
                        return normalizedFrame;
                    })
                } : undefined,
                value: normalized
            };
        });
        if (matchedUUIDs.size === 0) return;
        const boundedMatches = [];
        for (const match of matchedUUIDs){
            const candidate = [
                ...boundedMatches,
                match
            ];
            if (JSON.stringify(candidate).length > $0e0107334ae89504$var$MAX_MATCHED_UUID_TAG_LENGTH) break;
            boundedMatches.push(match);
        }
        event.tags = {
            ...event.tags,
            matchedUUID: JSON.stringify(boundedMatches)
        };
    }
    constructor({ accountId: accountId, dsn: dsn, environment: environment, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product, release: release, sentry: sentry }){
        this.breadcrumbGateway = new (0, $u3ka6.ConversationAssistantBreadcrumbGateway)();
        this.client = void 0;
        this.enabled = void 0;
        this.ignoreErrors = void 0;
        this.sentry = void 0;
        this.accountId = void 0;
        this.packageName = void 0;
        this.packageVersion = void 0;
        this.product = void 0;
        this.unsubscribeFromRequestObservations = void 0;
        this.accountId = accountId;
        this.enabled = environment === 'production';
        this.ignoreErrors = ignoreErrors;
        this.packageName = packageName;
        this.packageVersion = packageVersion;
        this.product = product;
        this.sentry = sentry;
        this.client = new sentry.BrowserClient({
            attachStacktrace: true,
            autoSessionTracking: false,
            dsn: dsn,
            enabled: this.enabled,
            environment: environment,
            integrations: [],
            maxBreadcrumbs: 100,
            release: release,
            sendClientReports: true
        });
        this.unsubscribeFromRequestObservations = (0, $5rzIE.subscribeToRequestObservations)((observation)=>{
            this.breadcrumbGateway.add($0e0107334ae89504$var$requestObservationToBreadcrumb(observation));
        });
    }
}
module.exports["ConversationAssistantPrivateReporter"] = $0e0107334ae89504$export$7c63502cdfeff038;

});

parcelRegister("u3ka6", function(module, exports) {

var $fPSAz = parcelRequire("fPSAz");

const $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS = 100;
const $e73c9a6ea29f4dd8$var$MAX_MESSAGE_LENGTH = 500;
const $e73c9a6ea29f4dd8$var$MAX_DATA_VALUE_LENGTH = 200;
const $e73c9a6ea29f4dd8$var$COALESCE_WINDOW_MS = 5000;
const $e73c9a6ea29f4dd8$var$ALLOWED_DATA_KEYS = new Set([
    'action',
    'actionSubject',
    'actionSubjectId',
    'durationMs',
    'experience',
    'kind',
    'lifecycle',
    'method',
    'nextState',
    'operation',
    'outcome',
    'previousState',
    'repeatCount',
    'route',
    'screen',
    'state',
    'status',
    'surface',
    'touchpoint'
]);
const $e73c9a6ea29f4dd8$var$truncate = (value, maxLength)=>value.length > maxLength ? `${value.slice(0, maxLength - 1)}\u{2026}` : value;
const $e73c9a6ea29f4dd8$var$sanitizeString = (value, maxLength = $e73c9a6ea29f4dd8$var$MAX_DATA_VALUE_LENGTH)=>{
    const { normalized: normalized } = (0, $fPSAz.normalizeUUID)(value);
    const withoutQuery = normalized.replace(/([a-z][a-z0-9+.-]*:\/\/[^?\s]+)\?[^\s]*/gi, '$1');
    return $e73c9a6ea29f4dd8$var$truncate(withoutQuery, maxLength);
};
const $e73c9a6ea29f4dd8$var$sanitizeData = (data)=>{
    if (!data) return;
    const sanitized = Object.entries(data).reduce((result, [key, value])=>{
        if (!$e73c9a6ea29f4dd8$var$ALLOWED_DATA_KEYS.has(key) || value !== null && typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return result;
        if (typeof value === 'string') {
            const sanitizedValue = $e73c9a6ea29f4dd8$var$sanitizeString(value);
            result[key] = sanitizedValue;
        } else if (value !== null) result[key] = value;
        return result;
    }, {});
    return Object.keys(sanitized).length > 0 ? sanitized : undefined;
};
const $e73c9a6ea29f4dd8$var$sanitizeCategory = (category)=>{
    if (!category) return 'conversation-assistant.custom';
    const safeCategory = category.toLowerCase().replace(/[^a-z0-9._-]+/g, '-').slice(0, 80);
    return safeCategory.startsWith('conversation-assistant.') ? safeCategory : `conversation-assistant.${safeCategory}`;
};
const $e73c9a6ea29f4dd8$var$isCoalescable = (breadcrumb)=>breadcrumb.level === 'warning' || breadcrumb.level === 'error' || breadcrumb.category?.includes('store') === true;
class $e73c9a6ea29f4dd8$export$78d89786cb79630b {
    add(crumb) {
        const breadcrumb = this.sanitize(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
        if (!$e73c9a6ea29f4dd8$var$isCoalescable(breadcrumb)) {
            this.push(breadcrumb);
            return;
        }
        const key = JSON.stringify({
            category: breadcrumb.category,
            data: breadcrumb.data,
            level: breadcrumb.level,
            message: breadcrumb.message,
            type: breadcrumb.type
        });
        const pending = this.pendingCoalescedBreadcrumb;
        if (pending?.key === key) {
            pending.repeatCount += 1;
            return;
        }
        this.flushCoalescedSummary();
        this.push(breadcrumb);
        this.pendingCoalescedBreadcrumb = {
            key: key,
            breadcrumb: breadcrumb,
            repeatCount: 1,
            timer: setTimeout(()=>this.flushCoalescedSummary(), $e73c9a6ea29f4dd8$var$COALESCE_WINDOW_MS)
        };
    }
    snapshot() {
        this.flushCoalescedSummary();
        return this.breadcrumbs.map((breadcrumb)=>({
                ...breadcrumb,
                data: breadcrumb.data ? {
                    ...breadcrumb.data
                } : undefined
            }));
    }
    reset() {
        if (this.pendingCoalescedBreadcrumb) clearTimeout(this.pendingCoalescedBreadcrumb.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        this.breadcrumbs = [];
    }
    sanitize(breadcrumb) {
        const category = $e73c9a6ea29f4dd8$var$sanitizeCategory(breadcrumb.category);
        const data = $e73c9a6ea29f4dd8$var$sanitizeData(breadcrumb.data);
        const message = typeof breadcrumb.message === 'string' ? $e73c9a6ea29f4dd8$var$sanitizeString(breadcrumb.message, $e73c9a6ea29f4dd8$var$MAX_MESSAGE_LENGTH) : undefined;
        return {
            category: category,
            data: data,
            level: breadcrumb.level,
            message: message,
            timestamp: breadcrumb.timestamp ?? Date.now() / 1000,
            type: breadcrumb.type
        };
    }
    flushCoalescedSummary() {
        const pending = this.pendingCoalescedBreadcrumb;
        if (!pending) return;
        clearTimeout(pending.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        if (pending.repeatCount <= 1) return;
        this.push({
            ...pending.breadcrumb,
            data: {
                ...pending.breadcrumb.data,
                repeatCount: pending.repeatCount
            },
            message: pending.breadcrumb.message ? `${pending.breadcrumb.message} (repeated ${pending.repeatCount} times)` : `Breadcrumb repeated ${pending.repeatCount} times`,
            timestamp: Date.now() / 1000
        });
    }
    push(breadcrumb) {
        this.breadcrumbs.push(breadcrumb);
        if (this.breadcrumbs.length > $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS) this.breadcrumbs.splice(0, this.breadcrumbs.length - $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS);
    }
    constructor(){
        this.breadcrumbs = [];
        this.pendingCoalescedBreadcrumb = void 0;
    }
}
module.exports["ConversationAssistantBreadcrumbGateway"] = $e73c9a6ea29f4dd8$export$78d89786cb79630b;

});

parcelRegister("fPSAz", function(module, exports) {
const $155164db85c7fae0$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $155164db85c7fae0$var$ATLAS_HOST = 'home.atlassian.com';
const $155164db85c7fae0$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $155164db85c7fae0$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $155164db85c7fae0$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $155164db85c7fae0$var$ATLAS_HOST || parsedUrl.host === $155164db85c7fae0$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$155164db85c7fae0$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $155164db85c7fae0$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($155164db85c7fae0$var$UUID_REGEX) || [];
    const normalized = str.replace($155164db85c7fae0$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $155164db85c7fae0$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $155164db85c7fae0$export$5efaf8444170fe75;

});

parcelRegister("2AFxF", function(module, exports) {
const $a1cdab547537e98f$export$33f86b6cbc947514 = (isIsolatedReporterEnabled)=>{
    let selected;
    return {
        get: ()=>{
            selected ?? (selected = isIsolatedReporterEnabled() ? 'isolatedPrivateV1' : 'legacyGlobal');
            return selected;
        },
        resetForTests: ()=>{
            selected = undefined;
        }
    };
};
module.exports["createPageSessionReportingPipelineSelector"] = $a1cdab547537e98f$export$33f86b6cbc947514;

});

parcelRegister("Ou0Zz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7TCQz = parcelRequire("7TCQz");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $cFVPs = parcelRequire("cFVPs");


var $hlvTd = parcelRequire("hlvTd");


var $89QZA = parcelRequire("89QZA");


var $eMlr8 = parcelRequire("eMlr8");


var $1jIs1 = parcelRequire("1jIs1");


var $nl5f2 = parcelRequire("nl5f2");

const $0fbd029e2a18e798$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $0fbd029e2a18e798$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $0fbd029e2a18e798$export$f30c856a07c48ee5 = ({ action: action, actionSubject: actionSubject, type: type })=>// message sent (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'sent' && actionSubject === 'message' || // aiMateActions displayed (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'displayed' && actionSubject === 'aiMateActions' || // aiInteraction initiated — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'initiated' }).
    action === 'initiated' && actionSubject === 'aiInteraction' || type === 'initiated' || // aiResult viewed — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'viewed' }).
    action === 'viewed' && actionSubject === 'aiResult' || type === 'viewed' || // aiResult actioned (client) — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'actioned' }).
    action === 'actioned' && actionSubject === 'aiResult' || type === 'actioned';
const $0fbd029e2a18e798$var$getRovoJourneyEventAttributes = ({ eventPayload: eventPayload, attributes: attributes, contextRovoJourneyId: contextRovoJourneyId })=>{
    const { [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: suppliedRovoJourneyId, ...attributesWithoutRovoJourneyId } = attributes;
    const rovoJourneyId = suppliedRovoJourneyId ?? contextRovoJourneyId;
    return {
        ...attributesWithoutRovoJourneyId,
        ...$0fbd029e2a18e798$export$f30c856a07c48ee5(eventPayload) && rovoJourneyId ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: rovoJourneyId
        } : {}
    };
};
const $0fbd029e2a18e798$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS = [
    'experience',
    'nextState',
    'outcome',
    'previousState',
    'screen',
    'state',
    'surface',
    'touchpoint'
];
const $0fbd029e2a18e798$var$getSentryAnalyticsBreadcrumb = (event)=>{
    const payload = event.payload;
    const attributes = payload?.attributes ?? {};
    const safeAttributes = $0fbd029e2a18e798$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS.reduce((result, key)=>{
        const value = attributes[key];
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') result[key] = value;
        return result;
    }, {});
    return {
        category: 'analytics',
        data: {
            action: payload?.action,
            actionSubject: payload?.actionSubject,
            actionSubjectId: payload?.actionSubjectId,
            ...safeAttributes
        },
        message: [
            payload?.action,
            payload?.actionSubject,
            payload?.actionSubjectId
        ].filter(Boolean).join(' ')
    };
};
const $0fbd029e2a18e798$export$e955abb82869dc84 = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $89QZA.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $cozmU.useCallback)((inputPayload)=>{
        const payload = (0, $7TCQz.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $0fbd029e2a18e798$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$0fbd029e2a18e798$var$DEFAULT_TAGS
    ];
    if ($0fbd029e2a18e798$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultAdopted: trackAIResultAdopted, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        skipAISessionValidation: options?.skipAISessionValidation,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire.
            return;
            const aiMateContextAttributes = (0, $nl5f2.getAttributesFromContexts)(event.context);
            // Fire. `event.update(...)` returns `undefined` for stub events (no `<AnalyticsListener>`
            // mounted, e.g. during SSR), so fall back to the original event and guard `.fire` with
            // optional chaining.
            const updatedEvent = event.update({
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: event.payload ?? rawEvent,
                    attributes: {
                        ...event.payload?.attributes ?? {},
                        ...aiMateContextAttributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event;
            updatedEvent?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $cozmU.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, chatEntryPoint: chatEntryPoint, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, inProductExperience: inProductExperience, mode: mode_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, spaceId: spaceId, isThirdPartyPromptConversation: isThirdPartyPromptConversation, thirdPartyPromptCohort: thirdPartyPromptCohort, thirdPartyConnectCount: thirdPartyConnectCount } = propertiesRef.current;
        return {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).chatEntryPoint]: chatEntryPoint,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).inProductExperience]: inProductExperience,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).mode]: mode_0,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).spaceId]: spaceId,
            // Gated on TRUE, not merely defined: the modal stamps `false` on every submit to clear
            // a previous 3P conversation, so a defined-check would let every later conversation
            // carry these keys with two `undefined`s.
            ...isThirdPartyPromptConversation ? {
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).isThirdPartyPromptConversation]: isThirdPartyPromptConversation,
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).thirdPartyPromptCohort]: thirdPartyPromptCohort,
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).thirdPartyConnectCount]: thirdPartyConnectCount
            } : {}
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $cozmU.useCallback)((payload_0)=>{
        // Handle tags
        const tags = [
            ...$0fbd029e2a18e798$var$DEFAULT_TAGS
        ];
        if ($0fbd029e2a18e798$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: sourceUnknown, subjectId: subjectIdUnknown, proactive: proactive, userGenerated: userGenerated, doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, connectorInfo: connectorInfo, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, tools: tools, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias_0, scenarioId: scenarioId, pageContext: pageContext, viewContext: viewContext, attributes: customAttributes } = payload_0;
        // source and subjectId are optional in the payload type but trackAI* functions require string.
        // The runtime value (including undefined) is intentionally passed through as-is.
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const source = sourceUnknown;
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const subjectId = subjectIdUnknown;
        const customAttributesRecord = customAttributes ?? {};
        const { [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId, ...customAttributesWithoutRovoJourneyId } = customAttributesRecord;
        const contextRovoJourneyId = propertiesRef.current.rovoJourneyId;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributesWithoutRovoJourneyId,
            ...$0fbd029e2a18e798$export$f30c856a07c48ee5(payload_0) && (customRovoJourneyId || contextRovoJourneyId) ? {
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId ?? contextRovoJourneyId
            } : {},
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat'
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (tools) attributes.tools = tools;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (connectorInfo && (payload_0.type === 'actioned' ? (0, $iDrrr.fg)('rovo_chat_connector_info_analytics_on_click') : (0, $iDrrr.fg)('rovo_chat_connector_info_analytics'))) attributes.connectorInfo = connectorInfo;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId_0) attributes.conversationChannelId = conversationChannelId_0;
        if (assistanceServiceConfigMinionAlias_0) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias_0;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        if (viewContext) attributes.viewContext = viewContext;
        let libAttributes = {
            ...attributes,
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0
        };
        const launchSource = propertiesRef.current.launchSource;
        const launchSourceAttribute = launchSource ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).launchSource]: launchSource
        } : {};
        switch(payload_0.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId,
                    doesNotMeetMAUCriteria: doesNotMeetMAUCriteria
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload_0.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                {
                    const actionedPayload = payload_0;
                    trackAIResultAction(actionedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'adopted':
                {
                    const adoptedPayload = payload_0;
                    trackAIResultAdopted(adoptedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            actionKey: adoptedPayload.actionKey,
                            rovoModifiedObjects: adoptedPayload.rovoModifiedObjects,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'feedback':
                {
                    const feedbackPayload = payload_0;
                    trackAIFeedbackSubmit(feedbackPayload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        propertiesRef,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIResultAdopted,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $cozmU.useCallback)((payload_1, options_0)=>{
        const extraTags = options_0?.removeDefaultTags ? [] : $0fbd029e2a18e798$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...'tags' in payload_1 && Array.isArray(payload_1.tags) ? payload_1.tags : [],
            ...maybeAtlasOperationalTags(payload_1)
        ]));
        const defaultAttributes = getDefaultAttributes();
        // `UIAnalyticsEvent | undefined` because in SSR (no `<AnalyticsListener>`),
        // `createAnalyticsEvent` and `event.update(...)` may return `undefined` stubs.
        let eventToBeLoggedWithSentry;
        if ((0, $7TCQz.isUIAnalyticsEvent)(payload_1)) {
            const aiMateContextAttributes_0 = (0, $nl5f2.getAttributesFromContexts)(payload_1.context);
            // `payload.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts. Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_0 = payload_1.update({
                ...payload_1.payload,
                tags: allTags,
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: payload_1.payload ?? {},
                    attributes: {
                        ...defaultAttributes,
                        // `payload.payload` is typed as defined on a UIAnalyticsEvent, but during SSR
                        // (and other no-listener contexts) the underlying event can be a stub whose
                        // `payload` is `undefined`. Guard the spread so the subscriber does not throw
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...payload_1.payload?.attributes ?? {},
                        ...aiMateContextAttributes_0
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? payload_1;
            updatedEvent_0?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_0;
        } else {
            const event_0 = createAnalyticsEvent({
                ...payload_1,
                tags: allTags,
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: payload_1,
                    attributes: {
                        ...defaultAttributes,
                        ...payload_1.attributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            });
            if (!event_0) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire or log.
            return;
            const aiMateContextAttributes_1 = (0, $nl5f2.getAttributesFromContexts)(event_0.context);
            // `event.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts (previously crashed with `Cannot read properties of undefined (reading
            // 'fire')`). Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_1 = event_0.update({
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: event_0.payload ?? payload_1,
                    attributes: {
                        // `event.payload` is normally defined when `createAnalyticsEvent` is wired up
                        // via `<AnalyticsListener>`, but in SSR (where no listener is mounted) the
                        // returned event can be a stub whose `payload` is `undefined`. Spreading
                        // without a guard previously crashed the ExperienceTracker subscriber with
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...event_0.payload?.attributes ?? {},
                        ...aiMateContextAttributes_1
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event_0;
            updatedEvent_1?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_1;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $hlvTd.addSentryBreadcrumb)((0, $hlvTd.isIsolatedSentryReportingSelected)() ? $0fbd029e2a18e798$var$getSentryAnalyticsBreadcrumb(eventToBeLoggedWithSentry) : `sendAnalyticsEvent event: ${JSON.stringify(eventToBeLoggedWithSentry)}`);
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes,
        propertiesRef
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["isRovoJourneyAllowlistedEvent"] = $0fbd029e2a18e798$export$f30c856a07c48ee5;
module.exports["useAnalytics"] = $0fbd029e2a18e798$export$e955abb82869dc84;

});

parcelRegister("7TCQz", function(module, exports) {
/// <reference types="node" />

var $dgpXm = parcelRequire("dgpXm");

const $6cd011fc484d182c$export$35f8383928ba8d7 = (obj)=>obj instanceof (0, $dgpXm.default) || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
module.exports["isUIAnalyticsEvent"] = $6cd011fc484d182c$export$35f8383928ba8d7;

});

parcelRegister("89QZA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $87e579b14b793016$var$initialState = {
    conversationChannelId: '',
    chatEntryPoint: undefined,
    experienceId: '',
    product: '',
    productHeader: '',
    inProductExperience: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $87e579b14b793016$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    propertiesRef: {
        current: {
            ...$87e579b14b793016$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $87e579b14b793016$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $cozmU.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $87e579b14b793016$export$1aefd27d2ed3c1c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId } = t0;
    let t1;
    if ($[0] !== launchSource || $[1] !== rovoJourneyId) {
        t1 = {
            ...$87e579b14b793016$var$initialState,
            launchSource: launchSource,
            rovoJourneyId: rovoJourneyId
        };
        $[0] = launchSource;
        $[1] = rovoJourneyId;
        $[2] = t1;
    } else t1 = $[2];
    const propertiesRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[3] !== launchSource) {
        t2 = ()=>{
            propertiesRef.current.launchSource = launchSource;
        };
        t3 = [
            launchSource
        ];
        $[3] = launchSource;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== rovoJourneyId) {
        t4 = ()=>{
            propertiesRef.current.rovoJourneyId = rovoJourneyId;
        };
        t5 = [
            rovoJourneyId
        ];
        $[6] = rovoJourneyId;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (properties)=>{
            propertiesRef.current = {
                ...propertiesRef.current,
                ...properties
            };
        };
        $[9] = t6;
    } else t6 = $[9];
    const setAnalyticsPropertiesWithoutRerender = t6;
    let t7;
    if ($[10] !== mode) {
        t7 = {
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        };
        $[10] = mode;
        $[11] = t7;
    } else t7 = $[11];
    const value = t7;
    let t8;
    if ($[12] !== children || $[13] !== value) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
            value: value
        }, children);
        $[12] = children;
        $[13] = value;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const propertiesRef = (0, $cozmU.useRef)({
        ...$87e579b14b793016$var$initialState,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    });
    // Sync the (possibly late/changing) prop into the ref after commit, so concurrent
    // renders that are paused or discarded never leak an uncommitted launch source.
    (0, $cozmU.useEffect)(()=>{
        propertiesRef.current.launchSource = launchSource;
    }, [
        launchSource
    ]);
    (0, $cozmU.useEffect)(()=>{
        propertiesRef.current.rovoJourneyId = rovoJourneyId;
    }, [
        rovoJourneyId
    ]);
    const setAnalyticsPropertiesWithoutRerender = (0, $cozmU.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
        value: value
    }, children);
};
const $87e579b14b793016$export$a00cd3c213413389 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId } = t0;
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const t1 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t2;
    if ($[0] !== iframeHostProduct || $[1] !== isInSmartCreateFlow || $[2] !== t1) {
        t2 = {
            sharedFeaturesInstrumentationId: t1,
            isInSmartCreateFlow: isInSmartCreateFlow,
            iframeHostProduct: iframeHostProduct
        };
        $[0] = iframeHostProduct;
        $[1] = isInSmartCreateFlow;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== source || $[5] !== t2) {
        t3 = {
            source: source,
            attributes: t2
        };
        $[4] = source;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const data = t3;
    const t4 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t5;
    if ($[7] !== isInSmartCreateFlow || $[8] !== t4) {
        t5 = {
            sharedFeaturesInstrumentationId: t4,
            isInSmartCreateFlow: isInSmartCreateFlow
        };
        $[7] = isInSmartCreateFlow;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== children || $[11] !== launchSource || $[12] !== mode || $[13] !== rovoJourneyId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
            mode: mode,
            launchSource: launchSource,
            rovoJourneyId: rovoJourneyId
        }, children);
        $[10] = children;
        $[11] = launchSource;
        $[12] = mode;
        $[13] = rovoJourneyId;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
            value: t5
        }, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== data || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: data
        }, t7);
        $[18] = data;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $cozmU.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow,
                iframeHostProduct: iframeHostProduct
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow,
        iframeHostProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
        value: {
            sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
            isInSmartCreateFlow: isInSmartCreateFlow
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
        mode: mode,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    }, children)));
};
const $87e579b14b793016$export$ab8aa3dfd687f012 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
} : ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $87e579b14b793016$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $87e579b14b793016$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $87e579b14b793016$export$ab8aa3dfd687f012;

});

parcelRegister("eMlr8", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $49f89fe5a40ece12$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    chatEntryPoint: 'chatEntryPoint',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    inProductExperience: 'inProductExperience',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias',
    skillSelectionSource: 'skillSelectionSource',
    // The Rovo Space a chat is scoped to (when any). Set on every event fired
    // while a space-scoped chat is active so "Space MAU" (unique users who
    // initiate a chat in a space) can be measured downstream.
    spaceId: 'spaceId',
    // Source surface that launched the conversation; emitted on result events only.
    // Runtime-validated against the launch-source allowlists at the pubsub boundary, so
    // only closed-vocabulary values ever reach analytics despite FollowUpSource's
    // `| string` fallback.
    launchSource: 'launchSource',
    // Quick Find-to-Chat journey correlation. Emitted only on the five funnel events
    // allowlisted by the analytics controller while the attributed conversation is active.
    rovoJourneyId: 'rovoJourneyId',
    // Set once a conversation is started from a third-party suggested prompt in the
    // Create-with-Rovo modal, so downstream events the 3P experiment does not own
    // (`message/sent`, `adopted/contentFinalized`) can be segmented by cohort.
    isThirdPartyPromptConversation: 'isThirdPartyPromptConversation',
    thirdPartyPromptCohort: 'thirdPartyPromptCohort',
    // Third-party apps connected from the in-thread connect prompt so far in this
    // conversation, so a later message can be read as post-connect without a join.
    thirdPartyConnectCount: 'thirdPartyConnectCount'
};
module.exports["AI_MATE_ATTRIBUTES"] = $49f89fe5a40ece12$export$8cffc8b2c93affd4;

});

parcelRegister("1jIs1", function(module, exports) {

var $iTJtk = parcelRequire("iTJtk");

const $70c81957c9ee94b4$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
const $70c81957c9ee94b4$var$REMIX_SOURCES = [
    'remix',
    'inlineRovoFromRemix',
    'remixModalFromToolbar',
    'remixModalFromBlockControls',
    'remixModalFromBlockMenu',
    'remixModalFromFloatingToolbar',
    'remixModalFromViewPageFloatingToolbar',
    'remixModalFromViewPageNudge',
    'remixModalFromNudge',
    'remixModalFromObjectLevelSidebar',
    'remixModalFromPasteMenu',
    'remixStagingArea',
    'remixModalFromMediaInserts'
];
const $70c81957c9ee94b4$export$e86f3aae41de8a7 = 'smartLinkRovoButton';
const $70c81957c9ee94b4$export$5a1bc70923e441e9 = new Set($70c81957c9ee94b4$var$REMIX_SOURCES);
const $70c81957c9ee94b4$export$c576fc434c88316f = new Set([
    'automation-discovery-meeting-notes-nudge',
    'automation-discovery-archive-page-nudge',
    'automation-discovery-status-updates-nudge',
    'automation-discovery-keep-up-to-date-dropdown-action',
    'automation-discovery-custom-prompt-dropdown-action',
    'jiraListChildCreateRovo',
    'jiraTimelineChildCreateRovo',
    'jsmSurveyAggregatedInsights',
    'recommendation-card-nudge'
]);
const $70c81957c9ee94b4$export$c377c6e02c795ae4 = new Set([
    'jiraAddViewCreateWithRovo'
]);
const $70c81957c9ee94b4$export$f57fd972b3024068 = (value, includeGatedLaunchSources = false)=>value !== undefined && ($70c81957c9ee94b4$export$c576fc434c88316f.has(value) || includeGatedLaunchSources && $70c81957c9ee94b4$export$c377c6e02c795ae4.has(value));
var $70c81957c9ee94b4$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_SLIDES"] = "confluence-aifc-slides";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_WHITEBOARD"] = "confluence-aifc-whiteboard";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_DATABASE"] = "confluence-aifc-database";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_LIVE_DOC"] = "confluence-aifc-live-doc";
    return AUTOSUGGEST_SOURCE;
}({});
const $70c81957c9ee94b4$export$f3c4b70a2cbe1eb3 = 'thirdPartyConnectPrompt';
module.exports["ANALYTICS_CHANNEL"] = $70c81957c9ee94b4$export$85183a312807388d;
module.exports["SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE"] = $70c81957c9ee94b4$export$e86f3aae41de8a7;
module.exports["REMIX_INTERACTION_SOURCES"] = $70c81957c9ee94b4$export$5a1bc70923e441e9;
module.exports["isAllowedLaunchSource"] = $70c81957c9ee94b4$export$f57fd972b3024068;
module.exports["AUTOSUGGEST_SOURCE"] = $70c81957c9ee94b4$export$406073150b1a408;
module.exports["THIRD_PARTY_CONNECT_PROMPT_SUBJECT"] = $70c81957c9ee94b4$export$f3c4b70a2cbe1eb3;

});

parcelRegister("nl5f2", function(module, exports) {

var $1Pvvv = parcelRequire("1Pvvv");


var $5oT0d = parcelRequire("5oT0d");

const $0e75beeba4a8395f$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $5oT0d.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $0e75beeba4a8395f$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$0e75beeba4a8395f$var$isSourceAndAttributes(x) || x[0, $1Pvvv.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $1Pvvv.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $0e75beeba4a8395f$export$d97c97ed77ff09e8;

});

parcelRegister("5oT0d", function(module, exports) {
const $19fd3c58da81b4e5$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent',
    'solutionComposer'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $19fd3c58da81b4e5$export$e31e24b63b7085fd;

});

parcelRegister("irnO2", function(module, exports) {

var $cNAch = parcelRequire("cNAch");


var $4MiWC = parcelRequire("4MiWC");

const $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    SEARCH_BROWSE_AGENTS: 'aiMateSearchBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    LOAD_AUTO_SUGGEST_SKILLS_LEGACY: 'aiMateAutoSuggestSkillsLegacy',
    LOAD_AUTO_SUGGEST_SKILLS_UNIFIED: 'aiMateAutoSuggestSkillsUnified',
    LOAD_CHAT_PROMPT_INPUT_SKILLS: 'aiMateChatPromptInputSkillsLoad',
    LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS: 'aiMateInlineChatPromptInputSkillsLoad',
    FETCH_CHAT: 'aiMateFetchChat',
    PREFETCH_CHAT: 'aiMatePrefetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    DUPLICATE_AGENT: 'aiMateDuplicateAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_TASK_MODE_MESSAGE: 'aiMateSendTaskModeMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE: 'aiMateSendConfirmedToolsTaskModeMessage',
    SEND_A2UI_ACTION: 'aiMateSendA2UIAction',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    LOAD_MORE_CONVERSATION_CHANNELS: 'aiMateLoadMoreConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
    PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents',
    PREFETCH_RECOMMENDED_SPACES: 'aiMatePrefetchRecommendedSpaces',
    OPEN_RECOMMENDED_SPACES: 'aiMateOpenRecommendedSpaces',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_TWC_ONBOARDING_MODAL_LAUNCH: 'aiMateTwcAifcOnboardingModalLaunch',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
    STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
    MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
    STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
    STUDIO_AUTOMATION_CREATE_RULE: 'aiMateStudioAutomationCreateRule',
    THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
    WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
    WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink',
    AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
    REMIX_START: 'aiMateRemixStart',
    REMIX_AIFC_HANDOFF: 'aiMateRemixAifcHandoff',
    FETCH_PROMPTS: 'aiMateFetchPrompts',
    FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
    FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
    REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal',
    REMIX_CREATE: 'aiMateRemixCreate',
    REMIX_OPEN_MENU: 'aiMateRemixOpenMenu',
    REMIX_SELECT_OPTION: 'aiMateRemixSelectOption',
    REMIX_SHOW_LOADING: 'aiMateRemixShowLoading',
    REMIX_VIEW: 'aiMateRemixView',
    REMIX_REGENERATE: 'aiMateRemixRegenerate',
    REMIX_INSERT: 'aiMateRemixInsert',
    REMIX_PASTE: 'aiMateRemixPaste',
    REMIX_COPY_FROM_PREVIEW: 'aiMateRemixCopyFromPreview',
    REMIX_DIAGRAM_PASTE_FINALIZE: 'aiMateRemixDiagramPasteFinalize',
    FETCH_TASKS: 'aiMateFetchTasks',
    LOAD_STICKY_SKILL_LISTENER: 'aiMateLoadStickySkillListener',
    /**
   * Tracks duplicating a Remix/MAUI app when its link is pasted into another
   * Confluence page. Started when the editor plugin detects a MAUI link in
   * the paste, succeeded once the duplicated app's URL has been swapped into
   * the editor doc, and failed if the duplicate API call (or any JS error in
   * the duplication flow) fails. When this experience fails, the
   * REMIX_INSERT experience is also failed so the overall paste-and-insert
   * flow is reflected in the SLO.
   */ REMIX_DUPLICATE_APP: 'aiMateRemixDuplicateApp',
    STUDIO_CREATE_AGENT: 'aiMateStudioCreateAgent',
    STUDIO_CREATE_AGENT_ASSIGN: 'aiMateStudioCreateAgentAssign',
    STUDIO_CREATE_AGENT_INVOKE: 'aiMateStudioCreateAgentInvoke',
    STUDIO_CREATE_AGENT_BUILD_AND_CHAT: 'aiMateStudioCreateAgentBuildAndChat',
    STUDIO_CREATE_AGENT_REFINE_IN_STUDIO: 'aiMateStudioCreateAgentRefineInStudio',
    STUDIO_CREATE_AGENT_RENDER: 'aiMateStudioCreateAgentRender',
    JIRA_SAVE_DRAFT_WORK_ITEM: 'aiMateJiraSaveDraftWorkItem',
    JIRA_RESOLVE_DRAFT_WORK_ITEM: 'aiMateJiraResolveDraftWorkItem',
    JIRA_CREATE_WORK_ITEMS_BULK: 'aiMateJiraCreateWorkItemsBulk',
    ROVO_SKILLS_PLAN_WORK_ITEM_CREATE: 'RovoSkillsPlanWorkItemCreate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE: 'RovoSkillsExecutionWorkItemCreate',
    ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE: 'RovoSkillsPlanWorkItemUpdate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE: 'RovoSkillsExecutionWorkItemUpdate',
    /**
   * Tracks the sender's end-to-end conversation-sharing funnel as a single
   * experience. Started when the share modal opens and succeeded only after
   * an existing or newly created share link is copied to the clipboard.
   * Unexpected hydration, persistence, share-creation, and clipboard errors
   * fail the experience. A `404` when loading existing share details is the
   * expected "not shared yet" state and does not fail the experience. Closing
   * the modal before any terminal state is recorded aborts the experience so
   * abandonment is excluded from the SLO.
   */ SHARE_CONVERSATION_SESSION: 'aiMateShareConversationSession',
    /**
   * Tracks the first action that reaches a terminal event while the Shared
   * chats tab in Rovo settings is active. Preview succeeds with `action` set
   * to `preview`; deleting a share or conversation succeeds or fails with
   * `action` set to `delete`. Later or overlapping terminal calls are ignored
   * by the underlying tracker. Closing the tab first aborts the experience.
   */ MANAGE_CONVERSATION_SHARES: 'aiMateManageConversationShares',
    /**
   * Tracks loading a shared conversation on the shared conversation preview
   * page, for both the sender previewing their own share and a recipient
   * opening a share link. Started when the route mounts and succeeded only
   * after the conversation has rendered. Errors retrieving or mapping the
   * share fail the experience. A link that never carried the parameters needed
   * to request a share aborts the experience, as does leaving the page before
   * the conversation renders, so malformed links and abandonment are still
   * recorded without counting against the SLO.
   */ VIEW_CONVERSATION_SHARE: 'aiMateViewConversationShare',
    /**
   * Tracks rendering the skill detail view of the skills directory, from either
   * Atlassian Studio or the Rovo Chat skills modal. Started when the detail
   * segment mounts and succeeded once the skill has rendered. Errors thrown
   * while loading or rendering the skill fail the experience.
   */ LOAD_SKILL_DETAIL_IN_SKILL_DIRECTORY: 'aiMateLoadSkillDetailInSkillDirectory',
    /**
   * Tracks rendering the products filter of the skills directory. Started when
   * the filter segment mounts and succeeded once the product list has
   * rendered. Errors loading the product dimension metadata fail the
   * experience.
   */ LOAD_SKILLS_DIRECTORY_PRODUCTS_FILTER: 'aiMateLoadSkillsDirectoryProductsFilter'
};
const $b6334bd5b5c71b1c$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (taskModeEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TASK_MODE_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $b6334bd5b5c71b1c$export$233a4307e330ea30 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.REMIX_REGENERATE
];
const $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d = {
    /** Browser-level network failure — request never reached Atlassian servers (e.g. VPN, firewall, no connectivity) */ CLIENT_FETCH_ERROR: 'clientFetchError',
    /** Rovo is not enabled for the user's organisation (product-not-active stream error) */ PRODUCT_NOT_ACTIVE: 'productNotActive',
    /** User is not authenticated or lacks permission (HTTP 401/403) */ AUTH_OR_PERMISSION_ERROR: 'authOrPermissionError',
    /** Request was rejected by rate limiting or quota admission control (HTTP 429) */ RATE_LIMIT_ERROR: 'rateLimitError'
};
const $b6334bd5b5c71b1c$export$315c6d415b08d278 = {
    /** Experience started (intent detection decided on a creatable/Remix action) */ STARTED_AT: 'previewCardRenderStartedAtMs',
    /** Most recent ACTION_PART received */ ACTION_PART_AT: 'previewCardRenderActionPartAtMs',
    /** ACTION_COMPLETE received */ ACTION_COMPLETE_AT: 'previewCardRenderActionCompleteAtMs',
    /** SmartCreatePreviewCard mounted */ CARD_MOUNTED_AT: 'previewCardRenderCardMountedAtMs',
    /** SmartCreatePreviewCard mounted but used a non-instrumented branch. */ ROUTED_TO_NON_INSTRUMENTED_BRANCH_AT: 'previewCardRenderRoutedToNonInstrumentedBranchAtMs'
};
const $b6334bd5b5c71b1c$export$754812bba125b4c4 = {
    /** Why the experience succeeded or aborted. */ TERMINAL_REASON: 'previewCardRenderTerminalReason'
};
const $b6334bd5b5c71b1c$export$51e40ef74b0123bc = {
    /** Action status on the ACTION_PREPARE chunk */ ACTION_PREPARE_STATUS: 'previewCardRenderActionPrepareStatus',
    /** Action status on the most recent ACTION_PART chunk */ ACTION_PART_STATUS: 'previewCardRenderActionPartStatus',
    /** Action status on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_STATUS: 'previewCardRenderActionCompleteStatus',
    /** Action key on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_KEY: 'previewCardRenderActionCompleteKey'
};
const $b6334bd5b5c71b1c$export$b49585ccbc2980b5 = {
    STARTED_AT: 'previewContentStartedAtMs',
    EMBED_URL_RESOLVED_AT: 'previewContentEmbedUrlResolvedAtMs',
    IFRAME_MOUNTED_AT: 'previewContentIframeMountedAtMs',
    HANDSHAKE_RECEIVED_AT: 'previewContentHandshakeReceivedAtMs',
    IFRAME_LOADED_AT: 'previewContentIframeLoadedAtMs'
};
const $b6334bd5b5c71b1c$export$449b821dadec8760 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$b6334bd5b5c71b1c$export$233a4307e330ea30
];
const $b6334bd5b5c71b1c$export$ebde7a14f059b67f = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    PREVIEW_VISIBLE: 'preview_visible'
};
const $b6334bd5b5c71b1c$export$35724980a513a99d = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.PREVIEW_VISIBLE
    }
];
const $b6334bd5b5c71b1c$export$13437d7a030ee3e7 = new (0, $cNAch.UFOExperience)('remix-generate-preview', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$35724980a513a99d
    ]
});
const $b6334bd5b5c71b1c$export$bef09d36689d0f74 = {
    SUBMIT: 'submit',
    // mark the start of the experience when the user submits the edit request
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    // mark when we receive the ACTION_COMPLETE event from the backend
    NODE_INSERTED: 'node_inserted' // mark when the new app node is inserted into the editor
};
const $b6334bd5b5c71b1c$export$222a56424ec38dc0 = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'insertion_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.NODE_INSERTED
    }
];
const $b6334bd5b5c71b1c$export$a143927e9fe401a2 = new (0, $cNAch.UFOExperience)('remix-edit-existing', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$222a56424ec38dc0
    ]
});
const $b6334bd5b5c71b1c$export$5806cfefce9dc0ad = {
    PASTE_DETECTED: 'paste_detected',
    EMBED_LOADED: 'embed_loaded'
};
const $b6334bd5b5c71b1c$export$c39e7538132ae645 = [
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$5806cfefce9dc0ad.PASTE_DETECTED,
        endMark: $b6334bd5b5c71b1c$export$5806cfefce9dc0ad.EMBED_LOADED
    }
];
const $b6334bd5b5c71b1c$export$cf4d370f87e7f73d = new (0, $cNAch.UFOExperience)('remix-paste-render-embed', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$c39e7538132ae645
    ]
});
let $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
const $b6334bd5b5c71b1c$export$c0c3ed9d934fa9fe = (metadata)=>{
    if ($b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = true;
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.start();
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.mark($b6334bd5b5c71b1c$export$5806cfefce9dc0ad.PASTE_DETECTED);
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
};
const $b6334bd5b5c71b1c$export$aa07d60d01b2c5e3 = (metadata)=>{
    if (!$b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.mark($b6334bd5b5c71b1c$export$5806cfefce9dc0ad.EMBED_LOADED);
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.success();
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
};
const $b6334bd5b5c71b1c$export$2ed37a75e20c9dc7 = (error, metadata)=>{
    if (!$b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.failure({
        metadata: {
            reason: error.message
        }
    });
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
};
module.exports["ExperienceName"] = $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1;
module.exports["sendMessageExperienceName"] = $b6334bd5b5c71b1c$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $b6334bd5b5c71b1c$export$233a4307e330ea30;
module.exports["SLOExclusionReason"] = $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d;
module.exports["PreviewCardRenderStage"] = $b6334bd5b5c71b1c$export$315c6d415b08d278;
module.exports["PreviewCardRenderDiagnosticAttribute"] = $b6334bd5b5c71b1c$export$754812bba125b4c4;
module.exports["PreviewCardRenderActionAttribute"] = $b6334bd5b5c71b1c$export$51e40ef74b0123bc;
module.exports["PreviewContentStage"] = $b6334bd5b5c71b1c$export$b49585ccbc2980b5;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $b6334bd5b5c71b1c$export$449b821dadec8760;
module.exports["REMIX_GENERATE_PREVIEW_MARKS"] = $b6334bd5b5c71b1c$export$ebde7a14f059b67f;
module.exports["remixGeneratePreviewExperience"] = $b6334bd5b5c71b1c$export$13437d7a030ee3e7;
module.exports["REMIX_EDIT_EXISTING_MARKS"] = $b6334bd5b5c71b1c$export$bef09d36689d0f74;
module.exports["remixEditExistingExperience"] = $b6334bd5b5c71b1c$export$a143927e9fe401a2;
module.exports["startRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$c0c3ed9d934fa9fe;
module.exports["succeedRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$aa07d60d01b2c5e3;
module.exports["failRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$2ed37a75e20c9dc7;

});

parcelRegister("1XM8n", function(module, exports) {
/**
 * Determines the owning team for a failure event based on the experience task name,
 * error message, and optional attributes (e.g. actionKey).
 *
 * The rules are derived from the AIFC Top Baseline Errors report and use regex matching
 * to handle error messages that contain dynamic values (UUIDs, IDs, hashes, etc).
 *
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/6822974693/Apr+13-14+2026+-+AIFC+Top+Baseline+Errors
 */ 
var $irnO2 = parcelRequire("irnO2");

var $8fc2212d0df9a0a6$export$e196c5257e9c94dd = /*#__PURE__*/ function(OwningTeam) {
    OwningTeam["AifcFoundations"] = "AIFC Foundations";
    OwningTeam["EditorAi"] = "Editor AI";
    OwningTeam["RovoChat"] = "Rovo Chat";
    OwningTeam["Whiteboards"] = "Whiteboards";
    OwningTeam["Databases"] = "Databases";
    OwningTeam["JiraAifc"] = "Jira AIFC";
    OwningTeam["Pulsar"] = "Pulsar";
    return OwningTeam;
}({});
/**
 * Step 1 — Experience-specific error rules.
 * These are checked first and only when the experience name matches.
 */ const $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES = [
    {
        pattern: /Something went wrong on Rovo's end. Please try sending your message again./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*whiteboard/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*database/i,
        team: "Databases",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*page/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The orchestrator reached its depth limit and the ConfluenceCreationTool was not invoked./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /Could not create content of type \w+ in the Confluence staging area./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "Editor AI",
        experiences: [
            (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    }
];
/**
 * Step 2 — Global error rules that apply across all experiences.
 */ const $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES = [
    {
        pattern: /network error/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An error occurred. Please try again later./i,
        team: "Rovo Chat"
    },
    {
        pattern: /Failed to fetch/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An unknown error occurred/i,
        team: "Rovo Chat"
    },
    {
        pattern: /\[Code 403\] {"code":403,"message":"You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help."}/i,
        team: "Rovo Chat"
    },
    {
        pattern: /AIFC stream received only preamble but no <todo_list>, SVG or whiteboards XML.*/i,
        team: "Whiteboards"
    },
    {
        pattern: /No sizing converter defined for element type 'mindmap'/i,
        team: "Whiteboards"
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards"
    },
    {
        pattern: /Could not find database:/i,
        team: "Databases"
    }
];
/**
 * Step 3 — Default team ownership per experience.
 * Used as a fallback when no error-pattern rule matches.
 */ const $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE = new Map([
    [
        (0, $irnO2.ExperienceName).AIFC_FINALIZE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_MODAL_SESSION,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT,
        "Editor AI"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_LEGACY,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).SHARE_CONVERSATION_SESSION,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).MANAGE_CONVERSATION_SHARES,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).VIEW_CONVERSATION_SHARE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE,
        "Pulsar"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE,
        "Pulsar"
    ]
]);
const $8fc2212d0df9a0a6$export$d6e429d0895093 = (errorMessage, experienceName)=>{
    if (!errorMessage) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    // Step 1: Experience-specific error-pattern rules
    if (experienceName) for (const rule of $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES){
        if (rule.experiences.includes(experienceName) && rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 2: Global error-pattern rules
    for (const rule of $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES){
        if (rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 3: Default team for this experience
    if (experienceName) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    return undefined;
};
module.exports["getOwningTeam"] = $8fc2212d0df9a0a6$export$d6e429d0895093;

});

parcelRegister("8YL3U", function(module, exports) {
class $f2446ffb8af04183$export$79c3dc6f15d36f18 {
    onVisibilityChange(isHidden) {
        const now = performance.now();
        if (isHidden) {
            if (this.lastHiddenAt === null) this.lastHiddenAt = now;
            if (this.firstHiddenOffsetMs === null) this.firstHiddenOffsetMs = now - this.startTime;
        } else if (this.lastHiddenAt !== null) {
            this.totalHiddenMs += now - this.lastHiddenAt;
            this.lastHiddenAt = null;
        }
    }
    getAttributes(doc) {
        const now = performance.now();
        const elapsed = now - this.startTime;
        let totalHiddenMs = this.totalHiddenMs;
        if (this.lastHiddenAt !== null) totalHiddenMs += now - this.lastHiddenAt;
        const tabHiddenProportion = elapsed > 0 ? totalHiddenMs / elapsed : 0;
        return {
            isActiveTab: doc ? doc.visibilityState === 'visible' : true,
            tabHiddenProportion: tabHiddenProportion,
            tabFirstHiddenOffsetMs: this.firstHiddenOffsetMs
        };
    }
    constructor(doc){
        this.startTime = void 0;
        this.totalHiddenMs = 0;
        this.lastHiddenAt = void 0;
        this.firstHiddenOffsetMs = void 0;
        this.startTime = performance.now();
        const isHidden = doc?.visibilityState === 'hidden';
        this.lastHiddenAt = isHidden ? this.startTime : null;
        this.firstHiddenOffsetMs = isHidden ? 0 : null;
    }
}
module.exports["TabVisibilityTracker"] = $f2446ffb8af04183$export$79c3dc6f15d36f18;

});

parcelRegister("5XWbo", function(module, exports) {
const $8801d8511b175030$export$e0744546db5b6189 = 'rovo_chat_sites_source_filter';
module.exports["ROVO_CHAT_SITES_SOURCE_FILTER_GATE"] = $8801d8511b175030$export$e0744546db5b6189;

});

parcelRegister("bxkJA", function(module, exports) {

var $fCunh = parcelRequire("fCunh");


var $8A2GO = parcelRequire("8A2GO");

const $c3ad42ae8c5c5089$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $c3ad42ae8c5c5089$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $c3ad42ae8c5c5089$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $c3ad42ae8c5c5089$export$c162f3e7456e473f = [
    'rovo_default',
    'professional',
    'creative',
    'empathetic'
];
const $c3ad42ae8c5c5089$export$a461d78149e66005 = [
    'shorter',
    'neutral',
    'longer'
];
const $c3ad42ae8c5c5089$export$42a434f431015fce = [
    'less_structured',
    'neutral',
    'more_structured'
];
const $c3ad42ae8c5c5089$export$312f4aeec9b65640 = [
    'none',
    'neutral',
    'more'
];
const $c3ad42ae8c5c5089$export$f3430750c3a3992d = [
    'enabled',
    'disabled'
];
var $c3ad42ae8c5c5089$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $c3ad42ae8c5c5089$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $c3ad42ae8c5c5089$export$77c9504201bdfdea = 'PROMPT_TILE';
const $c3ad42ae8c5c5089$export$7fe06c6ae176663 = 'third-party';
const $c3ad42ae8c5c5089$var$entityTypeMap = {
    person: 'Person',
    Person: 'Person',
    inferred_project: 'InferredProject',
    InferredProject: 'InferredProject'
};
const $c3ad42ae8c5c5089$export$d6de2556d50e53b4 = (message)=>({
        sentence: message.sentence,
        entities: message.entities.map((entity)=>({
                type: $c3ad42ae8c5c5089$var$entityTypeMap[entity.type],
                mention: entity.mention,
                start: entity.start,
                end: entity.end,
                ari: entity.ari,
                canonicalName: entity.canonical_name,
                confidenceScore: entity.confidence_score
            }))
    });
const $c3ad42ae8c5c5089$export$fb661125ffb29bd6 = (message)=>{
    return $c3ad42ae8c5c5089$export$a69fab2afb88c2eb(message) || $c3ad42ae8c5c5089$export$6f965deda7f0960c(message) || $c3ad42ae8c5c5089$export$b4631726cbc1440a(message);
};
const $c3ad42ae8c5c5089$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $c3ad42ae8c5c5089$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $c3ad42ae8c5c5089$export$1af37a4715539580 = (message)=>Boolean(message.message_metadata?.sharedFromMessageId);
const $c3ad42ae8c5c5089$export$a6e5100ca2770191 = (message)=>message instanceof Object && $c3ad42ae8c5c5089$export$6f965deda7f0960c(message.message);
const $c3ad42ae8c5c5089$export$2403e128f2e81f8f = (message)=>message instanceof Object && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$5c1c15675df13ae5 = (message)=>$c3ad42ae8c5c5089$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $c3ad42ae8c5c5089$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $c3ad42ae8c5c5089$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $c3ad42ae8c5c5089$var$isOptionalNullableString = (value)=>value === undefined || value === null || typeof value === 'string';
const $c3ad42ae8c5c5089$export$2d3cb9d520902824 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'INTERACTION_CONCLUSION' || !$c3ad42ae8c5c5089$var$isRecord(message.message) || message.message.outcome !== 'SUCCEEDED' && message.message.outcome !== 'FAILED') return false;
    if (message.millisOffset !== undefined && typeof message.millisOffset !== 'number') return false;
    if (message.metadata != null && (!$c3ad42ae8c5c5089$var$isRecord(message.metadata) || !$c3ad42ae8c5c5089$var$isOptionalNullableString(message.metadata.request_id) || !$c3ad42ae8c5c5089$var$isOptionalNullableString(message.metadata.message_id))) return false;
    return true;
};
const $c3ad42ae8c5c5089$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $c3ad42ae8c5c5089$export$1e1cf807ece63df4 = (message)=>$c3ad42ae8c5c5089$export$d422a2733a3b5def(message) && message.message?.message_template === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $c3ad42ae8c5c5089$var$isRawEntityAnnotation = (value)=>$c3ad42ae8c5c5089$var$isRecord(value) && (value.type === 'person' || value.type === 'Person' || value.type === 'inferred_project' || value.type === 'InferredProject') && typeof value.mention === 'string' && typeof value.start === 'number' && Number.isFinite(value.start) && typeof value.end === 'number' && Number.isFinite(value.end) && typeof value.ari === 'string' && typeof value.canonical_name === 'string' && typeof value.confidence_score === 'number' && Number.isFinite(value.confidence_score);
const $c3ad42ae8c5c5089$export$6fb760a9d35f0551 = (message)=>$c3ad42ae8c5c5089$var$isRecord(message) && message.type === 'ENTITY_ANNOTATIONS' && $c3ad42ae8c5c5089$var$isRecord(message.message) && typeof message.message.sentence === 'string' && Array.isArray(message.message.entities) && message.message.entities.every($c3ad42ae8c5c5089$var$isRawEntityAnnotation);
const $c3ad42ae8c5c5089$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $c3ad42ae8c5c5089$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $c3ad42ae8c5c5089$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $c3ad42ae8c5c5089$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $c3ad42ae8c5c5089$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $c3ad42ae8c5c5089$var$AUTO_ACTION_APPROVAL_STATUSES = new Set([
    'REVIEWING',
    'AUTO_APPROVED',
    'AUTO_APPROVED_REQUIRES_HUMAN',
    'REQUIRES_HUMAN'
]);
const $c3ad42ae8c5c5089$var$isNullableString = (value)=>value === null || typeof value === 'string';
const $c3ad42ae8c5c5089$export$9082a8e48d820016 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'AUTO_ACTION_APPROVAL' || !$c3ad42ae8c5c5089$var$isRecord(message.message)) return false;
    const payload = message.message;
    const metadataIsValid = message.metadata === undefined || message.metadata === null || $c3ad42ae8c5c5089$var$isRecord(message.metadata) && (message.metadata.request_id === undefined || $c3ad42ae8c5c5089$var$isNullableString(message.metadata.request_id));
    const sequenceIdIsValid = message.sequence_id === undefined || typeof message.sequence_id === 'string';
    return typeof message.millisOffset === 'number' && Number.isFinite(message.millisOffset) && typeof payload.content === 'string' && typeof payload.status === 'string' && $c3ad42ae8c5c5089$var$AUTO_ACTION_APPROVAL_STATUSES.has(payload.status) && typeof payload.action_display_name === 'string' && typeof payload.tool_name === 'string' && $c3ad42ae8c5c5089$var$isNullableString(payload.action_key) && $c3ad42ae8c5c5089$var$isNullableString(payload.reason) && typeof payload.source === 'string' && typeof payload.risk_category === 'string' && typeof payload.policy_version === 'string' && $c3ad42ae8c5c5089$var$isNullableString(payload.model_id) && metadataIsValid && sequenceIdIsValid;
};
const $c3ad42ae8c5c5089$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $c3ad42ae8c5c5089$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $c3ad42ae8c5c5089$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $c3ad42ae8c5c5089$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $c3ad42ae8c5c5089$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $c3ad42ae8c5c5089$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $c3ad42ae8c5c5089$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $c3ad42ae8c5c5089$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $c3ad42ae8c5c5089$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $c3ad42ae8c5c5089$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $c3ad42ae8c5c5089$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $c3ad42ae8c5c5089$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $c3ad42ae8c5c5089$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $c3ad42ae8c5c5089$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $c3ad42ae8c5c5089$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $c3ad42ae8c5c5089$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $c3ad42ae8c5c5089$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $c3ad42ae8c5c5089$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($c3ad42ae8c5c5089$export$7898cc38956b9052(message) || $c3ad42ae8c5c5089$export$bb608d13a1268633(message));
const $c3ad42ae8c5c5089$export$d95e474df0d530df = (message)=>message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'MEMORY_UPDATE';
const $c3ad42ae8c5c5089$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($c3ad42ae8c5c5089$export$46e0fb5e4b019a49(message)) return false;
    if ($c3ad42ae8c5c5089$export$cde91b49af35d559(message)) return false;
    if ($c3ad42ae8c5c5089$export$6f74311d40862a9f(message)) return false;
    if ($c3ad42ae8c5c5089$export$b65c73c7e2d8d96f(message)) return false;
    if ($c3ad42ae8c5c5089$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $c3ad42ae8c5c5089$export$682514f3a8131b98 = (message)=>{
    return message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'THINK_DEEPER_TRIGGERED';
};
const $c3ad42ae8c5c5089$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $c3ad42ae8c5c5089$export$6275ff996073145e = (message)=>{
    if (!$c3ad42ae8c5c5089$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray(data.message?.content);
};
const $c3ad42ae8c5c5089$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $c3ad42ae8c5c5089$export$b8391261162989d9 = (message)=>$c3ad42ae8c5c5089$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $c3ad42ae8c5c5089$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $c3ad42ae8c5c5089$export$6ce1ccc24e75456f = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes?.errorCode === $c3ad42ae8c5c5089$export$5945515082cc2cbf;
const $c3ad42ae8c5c5089$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $c3ad42ae8c5c5089$export$bc96a6a479480590 = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $c3ad42ae8c5c5089$export$f8b1b75846492611 = (error)=>(0, $8A2GO.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $c3ad42ae8c5c5089$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $c3ad42ae8c5c5089$export$145ab74998a54a20 = (message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $c3ad42ae8c5c5089$export$75ceabc5bb9500e4 = (message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $c3ad42ae8c5c5089$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $c3ad42ae8c5c5089$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $c3ad42ae8c5c5089$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $c3ad42ae8c5c5089$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["isSSEMessage"] = $c3ad42ae8c5c5089$export$f78edfe5a93b58af;
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
module.exports["RESPONSE_TONES"] = $c3ad42ae8c5c5089$export$c162f3e7456e473f;
module.exports["RESPONSE_LENGTHS"] = $c3ad42ae8c5c5089$export$a461d78149e66005;
module.exports["RESPONSE_STRUCTURES"] = $c3ad42ae8c5c5089$export$42a434f431015fce;
module.exports["RESPONSE_EMOJIS"] = $c3ad42ae8c5c5089$export$312f4aeec9b65640;
module.exports["RESPONSE_TLDR_OPTIONS"] = $c3ad42ae8c5c5089$export$f3430750c3a3992d;
module.exports["SUGGESTED_PROMPT_TILE_STREAM_MESSAGE_TYPE"] = $c3ad42ae8c5c5089$export$77c9504201bdfdea;
module.exports["THIRD_PARTY_PROMPT_SOURCE_CONTENT_TYPE"] = $c3ad42ae8c5c5089$export$7fe06c6ae176663;
module.exports["normalizeEntityAnnotationsMessage"] = $c3ad42ae8c5c5089$export$d6de2556d50e53b4;
module.exports["isHumanMessage"] = $c3ad42ae8c5c5089$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $c3ad42ae8c5c5089$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $c3ad42ae8c5c5089$export$b4631726cbc1440a;
module.exports["isSharedSnapshotMessage"] = $c3ad42ae8c5c5089$export$1af37a4715539580;
module.exports["isAgentResponse"] = $c3ad42ae8c5c5089$export$a6e5100ca2770191;
module.exports["isStreamMessageWithMessage"] = $c3ad42ae8c5c5089$export$2403e128f2e81f8f;
module.exports["isInProgressStreamResponse"] = $c3ad42ae8c5c5089$export$5c1c15675df13ae5;
module.exports["isStreamInteractionConclusion"] = $c3ad42ae8c5c5089$export$2d3cb9d520902824;
module.exports["isStreamError"] = $c3ad42ae8c5c5089$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $c3ad42ae8c5c5089$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $c3ad42ae8c5c5089$export$e45102edbc73b240;
module.exports["isStreamEntityAnnotations"] = $c3ad42ae8c5c5089$export$6fb760a9d35f0551;
module.exports["isStreamReasoningPart"] = $c3ad42ae8c5c5089$export$51a109436d382715;
module.exports["isStreamActionPart"] = $c3ad42ae8c5c5089$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $c3ad42ae8c5c5089$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $c3ad42ae8c5c5089$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $c3ad42ae8c5c5089$export$7d94ce53d589f586;
module.exports["isStreamAutoActionApproval"] = $c3ad42ae8c5c5089$export$9082a8e48d820016;
module.exports["isStreamResearchStart"] = $c3ad42ae8c5c5089$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $c3ad42ae8c5c5089$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $c3ad42ae8c5c5089$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $c3ad42ae8c5c5089$export$cde91b49af35d559;
module.exports["isStreamTodoSnapshot"] = $c3ad42ae8c5c5089$export$4a6a601f69cf3c74;
module.exports["isStreamTaskStatus"] = $c3ad42ae8c5c5089$export$6b0058543411cb3a;
module.exports["isStreamResearchStepTitleShort"] = $c3ad42ae8c5c5089$export$ac74da022f74040a;
module.exports["isStreamSkillStart"] = $c3ad42ae8c5c5089$export$7898cc38956b9052;
module.exports["isStreamSkillEnd"] = $c3ad42ae8c5c5089$export$bb608d13a1268633;
module.exports["isStreamFastModeResponseAvailable"] = $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f;
module.exports["isStreamFastModeEnabled"] = $c3ad42ae8c5c5089$export$40cf419186312161;
module.exports["isStreamRemoveAnswerNow"] = $c3ad42ae8c5c5089$export$a83708fc4401682d;
module.exports["isStreamResearchStepSource"] = $c3ad42ae8c5c5089$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $c3ad42ae8c5c5089$export$cfccfd17b68ccb0;
module.exports["isStreamResearchStepIcons"] = $c3ad42ae8c5c5089$export$1fd230d6956c2575;
module.exports["isStreamResearchStepDocument"] = $c3ad42ae8c5c5089$export$3bc697eeff31bdf6;
module.exports["isStreamReconnectSupportPart"] = $c3ad42ae8c5c5089$export$c679ee34f7312895;
module.exports["isStreamResearchPayload"] = $c3ad42ae8c5c5089$export$46e0fb5e4b019a49;
module.exports["isStreamSkill"] = $c3ad42ae8c5c5089$export$6f74311d40862a9f;
module.exports["isStreamMemoryUpdate"] = $c3ad42ae8c5c5089$export$d95e474df0d530df;
module.exports["isStreamTrace"] = $c3ad42ae8c5c5089$export$fd5a05be03f147a0;
module.exports["isStreamThinkDeeperTriggered"] = $c3ad42ae8c5c5089$export$682514f3a8131b98;
module.exports["isFollowUpMessage"] = $c3ad42ae8c5c5089$export$aeae5b4fda357302;
module.exports["isStreamAgenticUi"] = $c3ad42ae8c5c5089$export$6275ff996073145e;
module.exports["isStreamHeartbeat"] = $c3ad42ae8c5c5089$export$b46beea5c82aa1b9;
module.exports["isActionExecutedSuccessfully"] = $c3ad42ae8c5c5089$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $c3ad42ae8c5c5089$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $c3ad42ae8c5c5089$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $c3ad42ae8c5c5089$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $c3ad42ae8c5c5089$export$bc96a6a479480590;
module.exports["isHipaaError"] = $c3ad42ae8c5c5089$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $c3ad42ae8c5c5089$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $c3ad42ae8c5c5089$export$b454081350f4a578;
module.exports["isScopeDeterminedMessage"] = $c3ad42ae8c5c5089$export$145ab74998a54a20;
module.exports["isSpaceSourceRecommendationsMessage"] = $c3ad42ae8c5c5089$export$75ceabc5bb9500e4;
module.exports["isStreamPromptRedaction"] = $c3ad42ae8c5c5089$export$f4111656f23d9b9b;
module.exports["isStreamPromptBlock"] = $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef;
module.exports["isStreamResponseRedaction"] = $c3ad42ae8c5c5089$export$f16ff8eb19967a97;
module.exports["isStreamResponseBlock"] = $c3ad42ae8c5c5089$export$55f7bd80eacbc51b;
module.exports["isStreamAttachmentBlock"] = $c3ad42ae8c5c5089$export$a1be74470d3c1fe9;
module.exports["isConfirmAction"] = $c3ad42ae8c5c5089$export$4af48296a8d61cec;

});

parcelRegister("fCunh", function(module, exports) {
const $885d54b804b288bc$export$e8114853eca81277 = 'ai-mate';
const $885d54b804b288bc$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $885d54b804b288bc$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $885d54b804b288bc$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $885d54b804b288bc$export$333e4f57333eadfa;

});

parcelRegister("8A2GO", function(module, exports) {
const $a4d06b5ca4d94b78$export$8de5b7b1f5c5cfb7 = 'convoai.rest.pinned.conversation.limit.exceeded';
class $a4d06b5ca4d94b78$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes, data){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
        /** Structured, non-user-facing details supplied by the API. */ this.data = void 0;
        this.data = data;
    }
}
const $a4d06b5ca4d94b78$export$89d83cc97c52a37 = (error)=>error instanceof $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
const $a4d06b5ca4d94b78$var$getRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) ? value : undefined;
const $a4d06b5ca4d94b78$var$getApiErrorAttributes = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error.errorAttributes;
    return $a4d06b5ca4d94b78$var$getRecord($a4d06b5ca4d94b78$var$getRecord(error)?.errorAttributes);
};
const $a4d06b5ca4d94b78$var$getStructuredErrorData = (error)=>{
    const errorRecord = $a4d06b5ca4d94b78$var$getRecord(error);
    return $a4d06b5ca4d94b78$var$getRecord(errorRecord?.data) ?? $a4d06b5ca4d94b78$var$getRecord($a4d06b5ca4d94b78$var$getRecord(errorRecord?.errorAttributes)?.data);
};
const $a4d06b5ca4d94b78$var$getValidCount = (value, minimum)=>typeof value === 'number' && Number.isInteger(value) && value >= minimum ? value : undefined;
const $a4d06b5ca4d94b78$export$45f7ada0fbd007df = (error)=>{
    const errorAttributes = $a4d06b5ca4d94b78$var$getApiErrorAttributes(error);
    if (errorAttributes?.errorCode !== $a4d06b5ca4d94b78$export$8de5b7b1f5c5cfb7) return undefined;
    const data = $a4d06b5ca4d94b78$var$getStructuredErrorData(error);
    if (!data) return {};
    const maxPinnedConversations = $a4d06b5ca4d94b78$var$getValidCount(data.maxPinnedConversations, 1);
    const pinnedCount = $a4d06b5ca4d94b78$var$getValidCount(data.pinnedCount, 0);
    return {
        ...maxPinnedConversations !== undefined && {
            maxPinnedConversations: maxPinnedConversations
        },
        ...pinnedCount !== undefined && {
            pinnedCount: pinnedCount
        }
    };
};
const $a4d06b5ca4d94b78$export$3c02d1a328d4d808 = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $a4d06b5ca4d94b78$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
module.exports["isApiError"] = $a4d06b5ca4d94b78$export$89d83cc97c52a37;
module.exports["getPinnedConversationLimitErrorData"] = $a4d06b5ca4d94b78$export$45f7ada0fbd007df;
module.exports["mapErrorToApiError"] = $a4d06b5ca4d94b78$export$3c02d1a328d4d808;

});

parcelRegister("7zss8", function(module, exports) {

const $b3b3d72d5c15ae5d$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};
module.exports["setRovoChatProduct"] = $b3b3d72d5c15ae5d$export$caa27b16709bc2df;

});

parcelRegister("gB5in", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $344aa3e9f3db9c3d$export$693ae5fbaa444eeb(params) {
    const { browserUrl: browserUrl, autoActionApprovalMode: autoActionApprovalMode, useCurrentBrowsingContext: useCurrentBrowsingContext, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, dashboardEditorContext: dashboardEditorContext, browserContext: browserContext, isBrowserContextBlocklisted: isBrowserContextBlocklisted = false, jiraWorkflowContext: jiraWorkflowContext, additionalContext: additionalContext, writingStyleContext: writingStyleContext, dashboardContext: dashboardContext, aiFeatureContext: aiFeatureContext, fileIds: fileIds, knowledgeOverride: knowledgeOverride, selectedCloudIdsOverride: selectedCloudIdsOverride, searchArtifact: searchArtifact, shouldExtractConversationScopes: shouldExtractConversationScopes } = params;
    const isBrowserSelectionContextGateEnabled = (0, $iDrrr.fg)('rovo_chat_browser_selection_context');
    const browserSelection = isBrowserSelectionContextGateEnabled ? browserContext?.context?.selection : undefined;
    return {
        // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
        // instead it depends on prompt intent to use it,
        // with useCurrentBrowsingContext we can ensure it is always used
        browser_url: browserUrl,
        ...autoActionApprovalMode ? {
            auto_action_approval_mode: autoActionApprovalMode
        } : {},
        ...useCurrentBrowsingContext === undefined ? {} : {
            useCurrentBrowsingContext: useCurrentBrowsingContext
        },
        webSearchEnabled: webSearchEnabled,
        ...sourceMode ? {
            sourceMode: sourceMode
        } : {},
        deepResearchEnabled: deepResearchEnabled,
        ...thinkDeeperEnabled ? {
            extendedThinkingEnabled: thinkDeeperEnabled
        } : {},
        ...alphaExtendedThinkingMode ? {
            alphaExtendedThinkingMode: alphaExtendedThinkingMode
        } : {},
        ...fastModeEnabled ? {
            fastModeEnabled: fastModeEnabled
        } : {},
        ...planModeEnabled ? {
            planModeEnabled: planModeEnabled,
            alphaExtendedThinkingMode: 'MARATHON',
            extendedThinkingEnabled: true
        } : {},
        ...editorContext ? {
            editor: editorContext
        } : {},
        ...whiteboardContext ? {
            whiteboardContext: whiteboardContext
        } : {},
        ...slidesContext ? {
            slidesContext: slidesContext
        } : {},
        ...databaseContext ? {
            databaseContext: databaseContext
        } : {},
        ...dashboardEditorContext ? {
            dashboardEditorContext: dashboardEditorContext
        } : {},
        // If browserUrl is inaccessible, fallback to htmlBody or canvasText if they exist
        // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
        ...browserContext && !isBrowserContextBlocklisted ? {
            browser: {
                htmlBody: browserContext.context?.htmlBody,
                canvasText: browserContext.context?.canvasText,
                ...browserSelection ? {
                    selection: browserSelection
                } : {}
            }
        } : {},
        jiraWorkflowContext: jiraWorkflowContext,
        ...additionalContext,
        ...writingStyleContext ? {
            writingStyleContext: writingStyleContext
        } : {},
        dashboardContext: dashboardContext,
        aiFeatureContext: aiFeatureContext,
        fileIds: fileIds,
        ...knowledgeOverride,
        ...selectedCloudIdsOverride,
        ...searchArtifact ? {
            search_artifact: searchArtifact
        } : {},
        ...shouldExtractConversationScopes !== undefined ? {
            shouldExtractConversationScopes: shouldExtractConversationScopes
        } : {}
    };
}
module.exports["buildMessageStreamRequestContext"] = $344aa3e9f3db9c3d$export$693ae5fbaa444eeb;

});

parcelRegister("bQQtO", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $c1455ae7f1250686$var$getMessageStreamHref = (product)=>{
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window.location.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
const $c1455ae7f1250686$export$d272e1989c4ab4bf = ({ browserContext: browserContext, browserContextSanitizer: browserContextSanitizer, product: product })=>{
    const browserContextUrl = browserContext?.context?.browserUrl;
    const isBrowserContextBlocklisted = Boolean(browserContextUrl && browserContextSanitizer?.isBlocklisted(browserContextUrl));
    const isBrowserUrlSuppressed = browserContextUrl === 'NO-URL' && (0, $4o0zT.isExperimentEnabled)('jira_free_gen_editor');
    if (isBrowserContextBlocklisted || isBrowserUrlSuppressed) return {
        browserUrl: '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
    return {
        browserUrl: browserContextUrl || $c1455ae7f1250686$var$getMessageStreamHref(product) || '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
};
module.exports["resolveMessageStreamBrowserUrl"] = $c1455ae7f1250686$export$d272e1989c4ab4bf;

});

parcelRegister("fDfQA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $k046L = parcelRequire("k046L");

async function* $6c7eb7a39a02f1c4$export$1f24b2b263bcfa75(response) {
    const reader = (0, $k046L.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readJsonStream"] = $6c7eb7a39a02f1c4$export$1f24b2b263bcfa75;

});

parcelRegister("k046L", function(module, exports) {
const $c70dfd75c754b14f$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
module.exports["getBufferReader"] = $c70dfd75c754b14f$export$f6383c3ea1307da9;

});

parcelRegister("emCLk", function(module, exports) {

var $k046L = parcelRequire("k046L");

const $b3957af9ca78f17a$var$parseSSEMessage = (message)=>{
    const parsed = {};
    const dataLines = [];
    for (const line of message.split('\n')){
        const trimmedLine = line.trim();
        const colonIndex = trimmedLine.indexOf(':');
        if (trimmedLine && colonIndex !== -1) {
            const field = trimmedLine.substring(0, colonIndex);
            const value = trimmedLine.substring(colonIndex + 1).trimStart();
            switch(field){
                case 'event':
                    parsed.eventType = value;
                    break;
                case 'data':
                    dataLines.push(value);
                    break;
                case 'id':
                    parsed.id = value;
                    break;
                default:
                    break;
            }
        }
    }
    if (dataLines.length) parsed.data = dataLines.join('\n');
    return parsed;
};
async function* $b3957af9ca78f17a$export$6dab2f647580dc69(response) {
    const reader = (0, $k046L.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const combined = `${remainder}${value}`;
            const parts = combined.split('\n\n'); // SSE messages are separated by double newlines
            // the last part may be incomplete — keep it for the next read
            remainder = parts.pop() ?? '';
            for (const chunk of parts)try {
                const parsed = $b3957af9ca78f17a$var$parseSSEMessage(chunk);
                if (parsed.data) {
                    const parsedData = JSON.parse(parsed.data);
                    yield {
                        __isSSEWrapper: true,
                        data: parsedData,
                        id: parsed.id,
                        eventType: parsed.eventType
                    };
                }
            } catch  {
            // ignore malformed JSON; keep streaming future valid messages
            }
        }
        // If the stream just ended and we still have a remainder, try to parse it once.
        if (doneStreaming && remainder) try {
            const parsed = $b3957af9ca78f17a$var$parseSSEMessage(remainder);
            if (parsed.data) {
                const parsedData = JSON.parse(parsed.data);
                yield {
                    __isSSEWrapper: true,
                    data: parsedData,
                    id: parsed.id,
                    eventType: parsed.eventType
                };
            }
        } catch  {
        // ignore malformed tail
        } finally{
            remainder = '';
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readSSEStream"] = $b3957af9ca78f17a$export$6dab2f647580dc69;

});

parcelRegister("5suST", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $751ca72a9993528e$export$3b20549d55cda4db = 'store-message-from-user-settings';
const $751ca72a9993528e$export$bd10ff38e53e4101 = 'actionable-follow-ups';
const $751ca72a9993528e$export$f447b2e2b8f0d61e = 'actionable-follow-ups-stacked';
/**
 * Maps each gated capability to the gate/experiment that enables it. Add new
 * capability/gate pairs here rather than introducing nested ternaries at the
 * call sites.
 */ const $751ca72a9993528e$var$GATED_CAPABILITIES = [
    {
        capability: $751ca72a9993528e$export$3b20549d55cda4db,
        isEnabled: ()=>(0, $iDrrr.fg)('ai_mate_store_messages_be_driven')
    }
];
/** Maps an experiment cohort to the capability header it opts the request into. */ const $751ca72a9993528e$var$ACTIONABLE_FOLLOW_UPS_CAPABILITY_BY_COHORT = {
    control: undefined,
    inline: $751ca72a9993528e$export$bd10ff38e53e4101,
    stacked: $751ca72a9993528e$export$f447b2e2b8f0d61e
};
/**
 * Resolves the actionable follow-ups experiment cohort and FIRES an exposure.
 *
 * Exposure is fired here — at the point we decide which capability header to send —
 * so that all cohorts (including `control`, which never receives a `◈` marker from
 * the backend) are exposed equally. Firing on client-side marker detection instead
 * would never expose the control cohort and would imbalance the experiment.
 */ const $751ca72a9993528e$var$resolveActionableFollowUpsCohort = ()=>(0, $cXtTj.default).getExperimentValue('rovo_chat_actionable_follow_ups_exp', 'cohort', 'control');
const $751ca72a9993528e$export$6656e8be041b8747 = (capabilities)=>{
    const enabledCapabilities = $751ca72a9993528e$var$GATED_CAPABILITIES.filter(({ isEnabled: isEnabled })=>isEnabled()).map(({ capability: capability })=>capability);
    const followUpsCapability = $751ca72a9993528e$var$ACTIONABLE_FOLLOW_UPS_CAPABILITY_BY_COHORT[$751ca72a9993528e$var$resolveActionableFollowUpsCohort()];
    if (followUpsCapability) enabledCapabilities.push(followUpsCapability);
    // useRovoChatCapabilities adds `actionable-follow-ups` to the capabilities list for non-sendMessage requests
    // but we want the actual value of the experiment in this case and to avoid sending both
    // TODO: remove when the experiment is cleaned up and we can rely on useRovoChatCapabilities entirely
    const capabilitiesWithoutInlineFollowups = capabilities?.filter((capability)=>capability !== $751ca72a9993528e$export$bd10ff38e53e4101);
    if (enabledCapabilities.length === 0) return capabilitiesWithoutInlineFollowups;
    return Array.from(new Set([
        ...capabilitiesWithoutInlineFollowups ?? [],
        ...enabledCapabilities
    ]));
};
module.exports["buildEffectiveCapabilities"] = $751ca72a9993528e$export$6656e8be041b8747;

});

parcelRegister("irsyK", function(module, exports) {

var $8A2GO = parcelRequire("8A2GO");


var $jTKfH = parcelRequire("jTKfH");

const $c641c5a09bfdfc34$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $c641c5a09bfdfc34$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $c641c5a09bfdfc34$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    let data;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { data: responseData, error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        data = typeof responseData === 'object' && responseData !== null && !Array.isArray(responseData) ? responseData : undefined;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $c641c5a09bfdfc34$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    const errorMessage = `[Code ${response.status}] ${outputErrorMessage}`;
    const errorAttributes = {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $jTKfH.getTraceIdFromResponse)(response)
    };
    throw new (0, $8A2GO.ApiError)(errorMessage, errorAttributes, data);
};
const $c641c5a09bfdfc34$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $c641c5a09bfdfc34$var$processErrorResponse({
        response: response
    });
    return response;
};
module.exports["addPath"] = $c641c5a09bfdfc34$export$4c25481b843feb0b;
module.exports["processResponse"] = $c641c5a09bfdfc34$export$21fcb6cfd5628534;

});

parcelRegister("7td41", function(module, exports) {
const $00fdf2622c1683af$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $00fdf2622c1683af$export$11cc4786742ed7c2;

});

parcelRegister("bkEBw", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");


var $3PJhM = parcelRequire("3PJhM");

const $ac118120c3114919$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $ac118120c3114919$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $ac118120c3114919$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $ac118120c3114919$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $ac118120c3114919$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (!(0, $3PJhM.isRecord)(cur)) return undefined;
        cur = cur[key];
    }
    return cur;
};
const $ac118120c3114919$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = (0, $3PJhM.isRecord)(obj) ? obj : {};
    return {
        ...base,
        [head]: $ac118120c3114919$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $ac118120c3114919$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $ac118120c3114919$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $ac118120c3114919$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $ac118120c3114919$var$toPathArr(p);
            const prevVal = $ac118120c3114919$var$getAtPath(prevData, pathArr);
            const nextVal = $ac118120c3114919$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            const updated = $ac118120c3114919$var$setAtPath(base, pathArr, accumulated);
            // `setAtPath` only returns the raw `value` when the path is empty; here
            // `pathArr` is always non-empty (derived from a configured rule path), so
            // the result is always the spread record branch.
            if ((0, $3PJhM.isRecord)(updated)) base = updated;
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $ac118120c3114919$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key, invocationId: invocationId } = actionPart.message;
    // Accumulate by `invocationId` when the part has one, so multiple same-`key` actions (e.g. several
    // page creates in a single message) stream independently; fall back to `key` for parts without an
    // invocationId. For single-action messages both resolve to the same action, so no experiment gate
    // is needed here.
    const existingActionIndex = invocationId ? actions.findIndex((action)=>action.invocationId === invocationId) : actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $ac118120c3114919$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $ac118120c3114919$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $ac118120c3114919$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $ac118120c3114919$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $ac118120c3114919$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $ac118120c3114919$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $ac118120c3114919$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAgentResponse(message.message)
    });
const $ac118120c3114919$export$4c47ae95c311c518 = '00000000-0000-0000-0000-000000000000';
const $ac118120c3114919$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads, displayContext)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads,
        ...displayContext ? {
            display_context: displayContext
        } : {}
    };
};
const $ac118120c3114919$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $bxkJA.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $ac118120c3114919$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $ac118120c3114919$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $ac118120c3114919$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $ac118120c3114919$export$efd4f6b5d168b654;
module.exports["NO_PARENT_MESSAGE_ID"] = $ac118120c3114919$export$4c47ae95c311c518;
module.exports["createHumanMessage"] = $ac118120c3114919$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $ac118120c3114919$export$3220a4ff7b3a96df;

});


//# sourceMappingURL=main.9cdf522b.js.map
